<template>
  <div class="training">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="banner">
      <img src="../../../assets/image/Training/banner.png" alt="">
    </div>
    <div class="main">
      <div class="form">
        <formTitle title="日常委托"></formTitle>
        <div class="formBody dailyCommission">
          <div class="formItem">
            <li-item text="日常体力不指定副本/BOSS （单价：3r/天  80r/月）" margin-right="100">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.dailyStamina.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <mySwitch :labelAry="[{label:'天',price:3},{label:'月',price:80}]"
                          :num="form.dailyCommission.dailyStamina.val"
                          @switch="(val)=>{form.dailyCommission.dailyStamina.price = val}"></mySwitch>
              </div>
            </li-item>
            <li-item text="日常体力指定副本/BOSS （单价：5r/天  140r/月）" margin-right="106">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.dailyStaminaBoss.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <mySwitch :labelAry="[{label:'天',price:5},{label:'月',price:140}]"
                          :num="form.dailyCommission.dailyStaminaBoss.val"
                          @switch="(val)=>{form.dailyCommission.dailyStaminaBoss.price = val}"></mySwitch>
              </div>
            </li-item>
            <li-item text="日常委托（单价：2r/天  50r/月）" margin-right="217">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.dailyCommission.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <mySwitch :labelAry="[{label:'天',price:2},{label:'月',price:50}]"
                          :num="form.dailyCommission.dailyCommission.val"
                          @switch="(val)=>{form.dailyCommission.dailyCommission.price = val}"></mySwitch>
              </div>
            </li-item>
            <li-item text="捡圣遗物狗粮（单价：7r/天  200r/月）" margin-right="181">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.dogFood.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <mySwitch :labelAry="[{label:'天',price:7},{label:'月',price:200}]"
                          :num="form.dailyCommission.dogFood.val"
                          @switch="(val)=>{form.dailyCommission.dogFood.price = val}"></mySwitch>
              </div>
            </li-item>
            <li-item text="（体委+周本+两期深渊+派遣+尘歌壶+声望+3个小活动+一个大活动）（单价：399r/月）" margin-right="133">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.sportsCommittee.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <div class="comob-month">
                  <div class="month">月</div>
                  <div class="priceTip" v-if="form.dailyCommission.sportsCommittee.val">
                    （价格：{{
                      (form.dailyCommission.sportsCommittee.val * form.dailyCommission.sportsCommittee.price).toFixed(2)
                    }}r）
                  </div>
                </div>
              </div>
            </li-item>
            <li-item text="精托和纪行一个版本（纪行满级+体委+周本+深渊+派遣+尘歌壶+声望+小活动+大活动）（单价：680r/月）" margin-right="20">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.sperReceptacle.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <div class="comob-month">
                  <div class="month">月</div>
                  <div class="priceTip" v-if="form.dailyCommission.sperReceptacle.val">
                    （价格：{{
                      (form.dailyCommission.sperReceptacle.val * form.dailyCommission.sperReceptacle.price).toFixed(2)
                    }}r）
                  </div>
                </div>
              </div>
            </li-item>
            <li-item text="秘境/Boss（单价：2r/次）" margin-right="251">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托次数</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.unchartedBoss.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                <div class="comob-month">
                  <div class="month">次</div>
                  <div class="priceTip" v-if="form.dailyCommission.unchartedBoss.val">
                    （价格：{{ (form.dailyCommission.unchartedBoss.val * form.dailyCommission.unchartedBoss.price).toFixed(2) }}r）
                  </div>
                </div>
              </div>
            </li-item>
            <li-item text="纪行10级（60r/周）" margin-right="292">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">委托时长</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.dailyCommission.chronicle.val" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>4)value=4"></el-input>
                <div class="comob-month">
                  <div class="month">周</div>
                  <div class="priceTip" v-if="form.dailyCommission.chronicle.val">
                    （价格：{{ (form.dailyCommission.chronicle.val * form.dailyCommission.chronicle.price).toFixed(2) }}r）
                  </div>
                </div>
              </div>
            </li-item>
          </div>
          <!--                    <div class="formItem">
                                <div class="comboTitle">
                                  <img src="../../../assets/image/Training/comob.png" alt="">
                                  套餐&emsp;(单选项）
                                </div>
                                <div class="comboList">
                                  <div class="comboItem" v-for="(item,index) in comboList" :key="index">
                                    <div class="combo-index">{{ `0${index + 1}` }}</div>
                                    <div class="combo-text">{{ item.text }}{{ item.price }}</div>
                                    <div class="li-item-text">委托时长</div>
                                    <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                                              v-model="form.dailyCommission.comob[`comob${index}`].val" type="number"
                                              onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                              oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                                              @input="DCcomobInputChange(index)"></el-input>
                                    <mySwitch v-if="item.unitPrice.length>1" :labelAry="item.unitPrice"
                                              :num="form.dailyCommission.comob[`comob${index}`].val"
                                              @switch="(val)=>{form.dailyCommission.comob[`comob${index}`].price = val}"></mySwitch>
                                    <div v-else class="comob-month">
                                      <div class="month">月</div>
                                      <div class="priceTip" v-if="form.dailyCommission.comob[`comob${index}`].val">
                                        （价格：{{ (form.dailyCommission.comob[`comob${index}`].val * item.unitPrice[0].price).toFixed(2) }}r）
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="formItem">
                                <div class="levelUpTitle">
                                  <span/>突破等级（可多选）
                                  <div class="levelUpTitle-tip"><span/>经验需号主自备，还需有体力</div>
                                </div>
                                <div class="formCheckbox">
                                  <div class="formCheckbox-Item" style="margin-bottom:0 "
                                       :class="{'formCheckbox-Item-Active':form.dailyCommission.levelUp.includes(item)}"
                                       v-for="(item,index) in levelUpList" :key="index" @click="levelUpChange(item)">
                                    <span class="levelUpItem-label">{{ item.label }}</span>
                                    <span class="levelUpItem-price">{{ item.price }}r</span>
                                  </div>
                                </div>
                              </div>-->

          <div class="formItem formTotal">
            日常委托总价：<span class="totalPrice">¥ {{ form.dailyCommissionTotal.toFixed(2) }}</span>
          </div>

        </div>

      </div>
      <div class="form">
        <formTitle title="神瞳类" multiple-choice></formTitle>
        <div class="formBody supernatural">
          <div class="formItem">
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item"
                   :class="{'formCheckbox-Item-Active':form.supernatural.includes(item),'formCheckbox-Item-Disable':item.disable}"
                   v-for="(item,index) in supernaturalList" :key="index" @click="supernaturalChange(item)">
                <span class="formCheckbox-Item-label">{{ item.label }}</span>
                <span class="lformCheckbox-Item-price">{{ item.price }}r</span>
              </div>
            </div>
          </div>
          <div class="formItem formTotal">
            神瞳类总价：<span class="totalPrice">¥ {{ form.supernaturalTotal.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="form">
        <formTitle title="树类等级提升"></formTitle>
        <div class="formBody sakuraTree">
          <div class="formItem">
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item"
                   :class="{'formCheckbox-Item-Active':form.sakuraTree.treeCombo.includes(item),'formCheckbox-Item-Disable':item.disable}"
                   v-for="(item,index) in treeComboList" :key="index" @click="treeComboChange(item)">
                <span class="formCheckbox-Item-label">{{ item.text }}</span>
                <span class="lformCheckbox-Item-price">{{ item.price }}r</span>
              </div>
            </div>
          </div>
          <div class="formItem">
            <li-item text="神樱树 1-30（单价：8r/级）" margin-right="145">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin1" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>29)value=29"
                          @change="treeLevelChange('treeLevelMin1',form.sakuraTree.treeLevelMin1)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax1" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin1"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>30)value=30"
                          @change="treeLevelChange('treeLevelMax1',form.sakuraTree.treeLevelMax1)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax1 && form.sakuraTree.treeLevelMin1 && form.sakuraTree.treeLevelMax1 - form.sakuraTree.treeLevelMin1 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax1 - form.sakuraTree.treeLevelMin1) * 8).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="神樱树 30-40（单价：11r/级）" margin-right="130">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin2" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>39)value=39"
                          @change="treeLevelChange('treeLevelMin2',form.sakuraTree.treeLevelMin2)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax2" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin2"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>40)value=40"
                          @change="treeLevelChange('treeLevelMax2',form.sakuraTree.treeLevelMax2)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax2 && form.sakuraTree.treeLevelMin2 && form.sakuraTree.treeLevelMax2 - form.sakuraTree.treeLevelMin2 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax2 - form.sakuraTree.treeLevelMin2) * 11).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="神樱树 40-50（单价：14r/级）" margin-right="131">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin3" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>49)value=49"
                          @change="treeLevelChange('treeLevelMin3',form.sakuraTree.treeLevelMin3)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax3" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin3"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>50)value=50"
                          @change="treeLevelChange('treeLevelMax3',form.sakuraTree.treeLevelMax3)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax3 && form.sakuraTree.treeLevelMin3 && form.sakuraTree.treeLevelMax3 - form.sakuraTree.treeLevelMin3 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax3 - form.sakuraTree.treeLevelMin3) * 14).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="梦之树 1-10（单价：15r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin4" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>9)value=9"
                          @change="treeLevelChange('treeLevelMin4',form.sakuraTree.treeLevelMin4)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax4" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin4"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>10)value=10"
                          @change="treeLevelChange('treeLevelMax4',form.sakuraTree.treeLevelMax4)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax4 && form.sakuraTree.treeLevelMin4 && form.sakuraTree.treeLevelMax4 - form.sakuraTree.treeLevelMin4 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax4 - form.sakuraTree.treeLevelMin4) * 15).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="梦之树 10-20（单价：17r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin5" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>19)value=19"
                          @change="treeLevelChange('treeLevelMin5',form.sakuraTree.treeLevelMin5)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax5" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin5"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>20)value=20"
                          @change="treeLevelChange('treeLevelMax5',form.sakuraTree.treeLevelMax5)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax5 && form.sakuraTree.treeLevelMin5 && form.sakuraTree.treeLevelMax5 - form.sakuraTree.treeLevelMin5 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax5 - form.sakuraTree.treeLevelMin5) * 17).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="梦之树 20-30（单价：19r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin6" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>29)value=29"
                          @change="treeLevelChange('treeLevelMin6',form.sakuraTree.treeLevelMin6)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax6" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin6"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>30)value=30"
                          @change="treeLevelChange('treeLevelMax6',form.sakuraTree.treeLevelMax6)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax6 && form.sakuraTree.treeLevelMin6 && form.sakuraTree.treeLevelMax6 - form.sakuraTree.treeLevelMin6 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax6 - form.sakuraTree.treeLevelMin6) * 19).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="梦之树 30-40（单价：21r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin7" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>39)value=39"
                          @change="treeLevelChange('treeLevelMin7',form.sakuraTree.treeLevelMin7)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax7" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin7"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>40)value=40"
                          @change="treeLevelChange('treeLevelMax7',form.sakuraTree.treeLevelMax7)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax7 && form.sakuraTree.treeLevelMin7 && form.sakuraTree.treeLevelMax7 - form.sakuraTree.treeLevelMin7 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax7 - form.sakuraTree.treeLevelMin7) * 21).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="梦之树 40-45（单价：23r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin8" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>44)value=44"
                          @change="treeLevelChange('treeLevelMin8',form.sakuraTree.treeLevelMin8)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax8" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin8"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>45)value=45"
                          @change="treeLevelChange('treeLevelMax8',form.sakuraTree.treeLevelMax8)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax8 && form.sakuraTree.treeLevelMin8 && form.sakuraTree.treeLevelMax8 - form.sakuraTree.treeLevelMin8 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax8 - form.sakuraTree.treeLevelMin8) * 23).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="梦之树 45-50（单价：26r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin9" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>49)value=49"
                          @change="treeLevelChange('treeLevelMin9',form.sakuraTree.treeLevelMin9)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax9" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin9"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>50)value=50"
                          @change="treeLevelChange('treeLevelMax9',form.sakuraTree.treeLevelMax9)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax9 && form.sakuraTree.treeLevelMin9 && form.sakuraTree.treeLevelMax9 - form.sakuraTree.treeLevelMin9 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax9 - form.sakuraTree.treeLevelMin9) * 26).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="露景泉 1-10（单价：15r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin10" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>9)value=9"
                          @change="treeLevelChange('treeLevelMin10',form.sakuraTree.treeLevelMin10)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax10" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin10"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>10)value=10"
                          @change="treeLevelChange('treeLevelMax10',form.sakuraTree.treeLevelMax10)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax10 && form.sakuraTree.treeLevelMin10 && form.sakuraTree.treeLevelMax10 - form.sakuraTree.treeLevelMin10 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax10 - form.sakuraTree.treeLevelMin10) * 15).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
            <li-item text="露景泉 10-20（单价：17r/级）" margin-right="139">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMin11" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>19)value=19"
                          @change="treeLevelChange('treeLevelMin11',form.sakuraTree.treeLevelMin11)"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.sakuraTree.treeLevelMax11" type="number"
                          :disabled="!form.sakuraTree.treeLevelMin11"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4);if(value>20)value=20"
                          @change="treeLevelChange('treeLevelMax11',form.sakuraTree.treeLevelMax11)"></el-input>
                <div class="priceTip"
                     v-if="form.sakuraTree.treeLevelMax11 && form.sakuraTree.treeLevelMin11 && form.sakuraTree.treeLevelMax11 - form.sakuraTree.treeLevelMin11 > 0">
                  （价格：{{ ((form.sakuraTree.treeLevelMax11 - form.sakuraTree.treeLevelMin11) * 17).toFixed(2) }}r）
                </div>
              </div>
            </li-item>
          </div>
          <!--          <div class="formItem">
                                <div class="comboTitle">
                                  <img src="../../../assets/image/Training/comob.png" alt="">
                                  套餐&emsp;(单选项）
                                </div>
                                <div class="comboList">
                                  <div class="comboItem" v-for="(item,index) in treeComboList" :key="index">
                                    <div class="combo-index">{{ `0${index + 1}` }}</div>
                                    <div class="combo-text" style="width: 344px">{{ item.text }}</div>
                                    <div class="li-item-text">价格：{{ item.price.toFixed(2) }}r</div>
                                    <el-checkbox v-model="item.checked" class="comboCheckbox" @change="treeComboChange(item)"/>
                                  </div>
                                </div>
                              </div>-->
          <div class="formItem formTotal">
            神樱树总价：<span class="totalPrice">¥ {{ form.sakuraTreeTotal.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="form">
        <formTitle title="地图探索" multiple-choice></formTitle>
        <div class="formBody mapExploration">
          <div class="formItem">
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item"
                   :class="{'formCheckbox-Item-Active':form.mapExploration.maps.includes(item),'formCheckbox-Item-Disable':item.disable}"
                   v-for="(item,index) in mapsList" :key="index" @click="mapslChange(item)">
                <span class="formCheckbox-Item-label">{{ item.label }}</span>
                <span class="lformCheckbox-Item-price">{{ item.price }}r</span>
              </div>
            </div>
          </div>
          <div class="formItem">
            <div class="comboTitle">
              <img src="../../../assets/image/Training/comob.png" alt="">
              套餐
              <div class="comboTip">温馨提示: 多选项中单个地区与套餐内地区重复则不可选择</div>
            </div>
            <div class="comboList">
              <div class="comboItem" v-for="(item,index) in mapsComboList" :key="index">
                <div class="combo-index">{{ index + 1 >= 10 ? index + 1 : `0${index + 1}` }}</div>
                <div class="combo-text" style="width: 809px;margin: 0 20px 0 0">{{ item.text }}</div>
                <div class="li-item-text">价格：{{ item.price.toFixed(2) }}r</div>
                <el-checkbox v-model="item.checked" class="comboCheckbox" @change="mapsComboChange(item,index)"/>
              </div>
            </div>
          </div>
          <!--          <div class="formItem">
                      <li-item text="补探索度 80-90（单价：1r/度）" margin-right="119">
                        <div slot="detail" class="li-item-detail">
                          <div class="li-item-text">度数提升</div>
                          <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                                    v-model="form.mapExploration.degreeOfExpMin1" type="number"
                                    onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                    oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                                    @change="degreeOfExpChange('degreeOfExpMin1',form.mapExploration.degreeOfExpMin1)"></el-input>
                          -
                          <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                                    v-model="form.mapExploration.degreeOfExpMax1" type="number"
                                    :disabled="!form.mapExploration.degreeOfExpMin1"
                                    onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                    oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                                    @change="degreeOfExpChange('degreeOfExpMax1',form.mapExploration.degreeOfExpMax1)"></el-input>
                          <div class="priceTip"
                               v-if="form.mapExploration.degreeOfExpMax1 && form.mapExploration.degreeOfExpMin1 &&form.mapExploration.degreeOfExpMax1 - form.mapExploration.degreeOfExpMin1 > 0">
                            （价格：{{ (form.mapExploration.degreeOfExpMax1 - form.mapExploration.degreeOfExpMin1).toFixed(2) }}r）
                          </div>
                        </div>
                      </li-item>
                      <li-item text="补探索度 90-100（单价：2r/度）" margin-right="110">
                        <div slot="detail" class="li-item-detail">
                          <div class="li-item-text">度数提升</div>
                          <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                                    v-model="form.mapExploration.degreeOfExpMin2" type="number"
                                    onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                    oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                                    @change="degreeOfExpChange('degreeOfExpMin2',form.mapExploration.degreeOfExpMin2)"></el-input>
                          -
                          <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                                    v-model="form.mapExploration.degreeOfExpMax2" type="number"
                                    :disabled="!form.mapExploration.degreeOfExpMin2"
                                    onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                    oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                                    @change="degreeOfExpChange('degreeOfExpMax2',form.mapExploration.degreeOfExpMax2)"></el-input>
                          <div class="priceTip"
                               v-if="form.mapExploration.degreeOfExpMax2 && form.mapExploration.degreeOfExpMin2 && form.mapExploration.degreeOfExpMax2 - form.mapExploration.degreeOfExpMin2 > 0">
                            （价格：{{
                              ((form.mapExploration.degreeOfExpMax2 - form.mapExploration.degreeOfExpMin2) * 2).toFixed(2)
                            }}r）
                          </div>
                        </div>
                      </li-item>
                    </div>-->
          <div class="formItem formTotal">
            地图探索总价：<span class="totalPrice">¥ {{ form.mapExplorationTotal.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="form">
        <formTitle title="材料搜集"></formTitle>
        <div class="formBody materialOther">
          <div class="material collectMaterials">
            <div class="collectMaterials-title">
              <span></span>采集材料
            </div>
            <div class="collectMaterials-body">
              <div class="formItem" v-for="(item,index) in materialList.slice(0,2)" :key="index"
                   style="display: flex;align-items: center">
                <div class="materialPrice">
                  {{ item.price }}r/个
                </div>
                <div class="materialList">
                  <div class="materialItem" v-for="(items,indexs) in item.list" :key="indexs">
                    <div class="materialItem-label">
                      {{ items }}
                    </div>
                    <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                              v-model="form.materialOther[`materialList${index}`][`material${indexs}`]"
                              style="margin: 0 0 0 10px"
                              type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                              oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                  </div>
                </div>

              </div>
              <div class="formItem" style="display: flex;align-items: center;border-bottom: none">
                <div class="materialPrice">
                  其他
                </div>
                <div class="materialList">
                  <div class="materialItem" v-for="(item,index) in rareMaterialList" :key="index">
                    <div class="materialItem-label">
                      {{ item.label }}
                    </div>
                    <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                              v-model="form.materialOther.rareMaterial[`material${index}`]" style="margin: 0 0 0 10px"
                              type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                              oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                    （{{ item.price }}r/{{ item.company }}）
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="material beatingMaterials">
            <div class="collectMaterials-title">
              <span></span>打怪材料
            </div>
            <div class="collectMaterials-body">
              <div class="formItem" v-for="(item,index) in materialList.slice(2,5)" :key="index"
                   style="display: flex;align-items: center">
                <div class="materialPrice">
                  <div>{{ item.price }}r/个</div>
                  <div>{{ item.tip }}</div>
                </div>
                <div class="materialList">
                  <div class="materialItem" v-for="(items,indexs) in item.list" :key="indexs">
                    <div class="materialItem-label">
                      {{ items }}
                    </div>
                    <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                              v-model="form.materialOther[`materialList${index+2}`][`material${indexs}`]"
                              style="margin: 0 0 0 10px"
                              type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                              oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                  </div>
                </div>

              </div>
              <div class="formItem" style="display: flex;align-items: center;border-bottom: none">
                <div class="materialPrice">
                  <div>稻妻特殊材料</div>
                  <div>(稻妻已开)</div>
                </div>
                <div class="materialList">
                  <div class="materialItem" v-for="(item,index) in rareMaterialList1" :key="index">
                    <div class="materialItem-label">
                      {{ item.label }}
                    </div>
                    <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                              v-model="form.materialOther.rareMaterial1[`material${index}`]" style="margin: 0 0 0 10px"
                              type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                              oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                    （{{ item.price }}r/{{ item.company }}）
                  </div>
                </div>
              </div>
              <div class="formItem" style="display: flex;align-items: center;border-bottom: none">
                <div class="materialPrice">
                  <div>丘丘人低掉落材料</div>
                </div>
                <div class="materialList">
                  <div class="materialItem" v-for="(item,index) in rareMaterialList2" :key="index">
                    <div class="materialItem-label">
                      {{ item.label }}
                    </div>
                    <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                              v-model="form.materialOther.rareMaterial2[`material${index}`]" style="margin: 0 0 0 10px"
                              type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                              oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                    （{{ item.price }}r/{{ item.company }}）
                  </div>
                </div>
              </div>
              <div class="formItem formItem-tip">
                温馨提示: 以上刷怪材料世界等级不足需要联系客服商议选择
              </div>
            </div>
          </div>
          <div class="formItem formTotal" style="border-bottom: none">
            材料搜集总价：<span class="totalPrice">¥ {{ form.materialOtherTotal.toFixed(2) }}</span>
          </div>

        </div>
      </div>
      <div class="form">
        <formTitle title="任务类" multiple-choice></formTitle>
        <div class="formBody taskClass">
          <div class="formItem">
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item" :class="{'formCheckbox-Item-Active':form.taskClass.includes(item)}"
                   v-for="(item,index) in taskClassList" :key="index" @click="taskClassChange(item)">
                <span class="formCheckbox-Item-label" style="margin: 0;">
                  {{ item.label }}
                </span>
              </div>
            </div>
            <div class="formItem-tip" style="margin: 0 0 15px">
              温馨提示: 以上内容具体咨询客服
            </div>
          </div>
          <div class="formItem formTotal">
            任务类总价：<span class="totalPrice">¥ {{ form.taskClassTotal.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="form">
        <formTitle title="角色/武器突破" multiple-choice></formTitle>
        <div class="formBody breachClass">
          <div class="formItem">
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item" :class="{'formCheckbox-Item-Active':form.breachClass.includes(item)}"
                   v-for="(item,index) in breachClassList" :key="index" @click="breachClassChange(item)">
                <span class="formCheckbox-Item-label" style="margin: 0;">
                  {{ item.label }}&emsp;&emsp;{{ item.price }}r
                </span>
              </div>
            </div>
          </div>
          <div class="formItem formTotal">
            角色/武器突破总价：<span class="totalPrice">¥ {{ form.breachClassTotal.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="form">
        <formTitle title="冒险等级"></formTitle>
        <div class="formBody adventureLevel">
          <div class="formItem">
            <div class="adventureComboTitle">
              <span></span>
              冒险等级(极速版）
            </div>
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item"
                   :class="{'formCheckbox-Item-Active':form.adventureLevel.adventureCombo.includes(item),'formCheckbox-Item-Disable':item.disable} "
                   v-for="(item,index) in adventureLevelCombo.slice(0,9)" :key="index"
                   @click="adventureLevelComboChange(item)">
                <span class="formCheckbox-Item-label adventureLevel-lebel">{{ item.label }}&emsp;{{
                    item.price
                  }}r</span>
                <span class="formCheckbox-Item-price adventureLevel-time">{{ item.timeText }}</span>
              </div>
            </div>
          </div>
<!--          <div class="formItem">
            <div class="adventureComboTitle">
              <span></span>
              冒险等级(普通版）
            </div>
            <div class="formCheckbox formCheckbox" style="margin: 0">
              <div class="formCheckbox-Item"
                   :class="{'formCheckbox-Item-Active':form.adventureLevel.adventureCombo.includes(item),'formCheckbox-Item-Disable':item.disable}"
                   v-for="(item,index) in adventureLevelCombo.slice(9,18)" :key="index"
                   @click="adventureLevelComboChange(item)">
                <span class="formCheckbox-Item-label adventureLevel-lebel">{{ item.label }}&emsp;{{
                    item.price
                  }}r</span>
                <span class="formCheckbox-Item-price adventureLevel-time">{{ item.timeText }}</span>
              </div>
            </div>
          </div>
          <div class="formItem">
            <li-item v-for="(item,index) in adventureLevelList" :key="index" :text="`${item.text}${item.priceText}`"
                     :margin-right="item.gap">
              <div slot="detail" class="li-item-detail">
                <div class="li-item-text">等级提升</div>
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.adventureLevel[`adventureLevelMin${index+4}`]" type="number"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          :disabled="(form.adventureLevel.adventureCombo.length>0  && form.adventureLevel.adventureCombo[0].speed === 'fast')"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                          @change="adventureLevelChange(`adventureLevelMin${index+4}`,form.adventureLevel[`adventureLevelMin${index+4}`])"></el-input>
                -
                <el-input placeholder="请输入" onpaste="return false" class="li-item-input"
                          v-model="form.adventureLevel[`adventureLevelMax${index+4}`]" type="number"
                          :disabled="!form.adventureLevel[`adventureLevelMin${index+4}`] || (form.adventureLevel.adventureCombo.length>0  && form.adventureLevel.adventureCombo[0].speed === 'fast')"
                          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                          oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"
                          @change="adventureLevelChange(`adventureLevelMax${index+4}`,form.adventureLevel[`adventureLevelMax${index+4}`])"></el-input>
                <div class="priceTip"
                     v-if="form.adventureLevel[`adventureLevelMax${index+4}`] && form.adventureLevel[`adventureLevelMin${index+4}`] && form.adventureLevel[`adventureLevelMax${index+4}`] - form.adventureLevel[`adventureLevelMin${index+4}`] > 0">
                  （价格：{{ adventureLevelTotalList[index] }}r）
                  &lt;!&ndash;                  {{&ndash;&gt;
                  &lt;!&ndash;                    ((form.adventureLevel[`adventureLevelMax${index}`] - form.adventureLevel[`adventureLevelMin${index}`]) * item.price).toFixed(2)&ndash;&gt;
                  &lt;!&ndash;                  }}r）&ndash;&gt;
                </div>
              </div>
            </li-item>
          </div>-->
          <div class="formItem formTotal">
            冒险等级任务类总价：<span class="totalPrice">¥ {{ form.adventureLevelTotal.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="form-tip">
        温馨提示：<br/>
        活动每期更新：请移步客服咨询下单<br/>
        深渊：请移步客服咨询下单<br/>
        成就：请移步客服咨询下单<br/>
        陪刷：请移步客服咨询下单<br/>
        <!--                温馨提示: 以上刷怪材料世界等级不足需要联系客服商议选择-->
      </div>
      <div class="form-footer">
        <div class="footer-card">
          <div class="footer-title">
            <div class="footer-total">
              购买表单
            </div>
            <div class="footer-btnGroup">
              <div class="footer-btn" @click="resetFormShow = true">
                <img src="../../../assets/image/Training/reset.png" alt="">
                重置选项
              </div>
              <div class="footer-btn" @click="copyForm">
                <img src="../../../assets/image/Training/copy.png" alt="">
                复制表单
              </div>
            </div>

          </div>
          <div class="footer-input">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请选择内容自动生成文本"
              disabled
              v-model="textarea">
            </el-input>
          </div>
        </div>
        <div class="footer-other">
          <div class="footer-price">
            合计：
            <span>
              ¥
              <span id="totalPrice">
                {{ total.toFixed(2) }}
              </span>
            </span>
          </div>
          <div class="footer-btnGroup">
            <div class="footer-btn-cusSer" @click="copyFormShow =  true">咨询客服</div>
            <div class="footer-btn-buy" @click="copyFormShow =  true">立即购买</div>
          </div>
        </div>
      </div>
      <!--      <div class="form">
              <formTitle title="自定义"></formTitle>
              <div class="formBody customize">
                <div class="formItem">
                  <li-item text="补款类（1r/件）" margin-right="10">
                    <div slot="detail" class="li-item-detail">
                      <div class="li-item-text">件数</div>
                      <el-input placeholder="请输入" onpaste="return false" class="li-item-input" v-model="form.customize"
                                type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                oninput="if(value == '0') value = ''; if(value.length>4)value=value.slice(0,4)"></el-input>
                      <div class="li-item-tip">
                        <span></span>
                        限时活动（具体咨询客服）
                      </div>
                    </div>
                  </li-item>
                  <el-input
                    class="remark"
                    type="textarea"
                    placeholder="请输入备注信息"
                    v-model="form.remark"
                    :autosize="{ minRows: 4}"
                    maxlength="500"
                    show-word-limit
                  />

                </div>
                <div class="formItem formTotal">
                  自定义总价：<span class="totalPrice">¥ {{ form.customize ? form.customize : 0 }}</span>
                </div>
              </div>
            </div>-->
    </div>

    <myDialog :show="resetFormShow" title="" text="是否重置所有选项" :closeFun="()=>{resetFormShow = false}">
      <div slot="btn">
        <div class="btnGroup">
          <div class="btn cancelBtn" @click="resetFormShow = false">取消</div>
          <div class="btn" @click="resetForm">重置</div>
        </div>
      </div>
    </myDialog>
    <myDialog :show="copyFormShow" title="" text="是否复制订单信息" :closeFun="()=>{copyFormShow = false}">
      <div slot="btn">
        <div class="btnGroup">
          <div class="btn cancelBtn" @click="copyFormShow = false">否</div>
          <div class="btn" @click="contactCustomerService">是</div>
        </div>
      </div>
    </myDialog>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import formTitle from "@/views/AllGame/Training/components/formTitle";
import liItem from "@/views/AllGame/Training/components/li-item"
import mySwitch from "@/views/AllGame/Training/components/mySwitch"
import * as math from 'mathjs'
import myDialog from "@/components/myDialog";

export default {
  name: "Training",
  components: {
    breadcrumb,
    formTitle,
    liItem,
    mySwitch,
    myDialog
  },
  data() {
    return {
      resetFormShow: false,
      copyFormShow: false,
      //面包屑
      breadcrumbList: [
        {link: 'AllGame', name: '全部游戏'},
        {
          link: 'Selectgame', name: '原神', query: {
            game_id: 26,
            game_alias: 'yuanshen5'
          }
        },
        {name: '代肝'},
      ],
      //日常委托 -- 套餐
      comboList: [
        {
          text: '清日常委托+日常清体力+派遣+纪行每日',
          price: '（单价：28r/周  80r/月）',
          unitPrice: [{label: '周', price: 28}, {label: '月', price: 80}]
        },
        {
          text: '清日常委托+清体力+派遣+周本全清+纪行每日 ',
          price: '（单价：34r/周  88r/月）',
          unitPrice: [{label: '周', price: 34}, {label: '月', price: 88}]
        },
        {
          text: '完美全托：委托+纪行+周本+体力+声望+派遣',
          price: '（单价：36r/周  90r/月）',
          unitPrice: [{label: '周', price: 36}, {label: '月', price: 90}]
        },
        {text: '精致托管：完美全托+大小版本活动', price: '（单价：188r/月）', unitPrice: [{label: '月', price: 188}]},
        {text: '尊贵VIP：精致托管+新图满探索+新图全任务+角色培养（4个）', price: '（单价：688r/月）', unitPrice: [{label: '月', price: 688}]},
      ],
      //日常委托 -- 突破等级
      levelUpList: [
        {label: '突破70级', price: 50},
        {label: '突破80级', price: 78},
      ],
      //神通类
      supernaturalList: [
        {label: '风神瞳', price: 50, id: 1, disable: false, associate: [1]},
        {label: '岩神瞳', price: 70, id: 2, disable: false, associate: [2]},
        {label: '雷神瞳', price: 100, id: 3, disable: false, associate: [3]},
        {label: '须弥—荒石苍漠/浮罗囿草神瞳（36颗）', price: 30, id: 9, disable: false, associate: []},
        {label: '须弥—千壑沙地草神瞳（55颗）', price: 40, id: 10, disable: false, associate: []},
        {label: '须弥沙漠草神瞳（70颗）', price: 50, id: 4, disable: false, associate: [5, 6]},
        {label: '须弥雨林草神瞳（110颗）', price: 110, id: 5, disable: false, associate: [4, 6]},
        {label: '全须弥神瞳', price: 220, id: 11, disable: false, associate: []},
        {label: '枫丹—水神瞳4.0版本（85颗）', price: 60, id: 12, disable: false, associate: []},
        {label: '甘露池', price: 40, id: 13, disable: false, associate: []},
        // {label: '须弥雨林+须弥沙漠草神瞳（180颗）', price: 150, id: 6, disable: false, associate: [4, 5, 6]},
        {label: '键纹全收集', price: 40, id: 7, disable: false, associate: []},
        {label: '流明石全收集', price: 30, id: 8, disable: false, associate: []},
      ],
      //地图探索 -- 地图
      mapsList: [
        {disable: false, id: 1, label: '蒙德—明冠山地', price: 45},
        {disable: false, id: 2, label: '蒙德—坠星山谷', price: 50},
        {disable: false, id: 3, label: '蒙德—苍风高地', price: 45},
        {disable: false, id: 4, label: '蒙德—风啸山坡', price: 45},
        {disable: false, id: 5, label: '璃月—珉林', price: 80},
        {disable: false, id: 6, label: '璃月—碧水原', price: 60},
        {disable: false, id: 7, label: '璃月—琼玑野', price: 60},
        {disable: false, id: 8, label: '璃月—云来海', price: 60},
        {disable: false, id: 9, label: '璃月—璃沙郊', price: 60},
        {disable: false, id: 10, label: '稻妻—鸣神岛', price: 60},
        {disable: false, id: 11, label: '稻妻—神无冢', price: 60},
        {disable: false, id: 12, label: '稻妻—八酝岛', price: 60},
        {disable: false, id: 13, label: '稻妻—海祈岛', price: 60},
        {disable: false, id: 14, label: '稻妻—清赖岛', price: 60},
        {disable: false, id: 15, label: '稻妻—鹤观', price: 60},
        {disable: false, id: 16, label: '须弥—善见地', price: 80},
        {disable: false, id: 17, label: '须弥—护世森', price: 60},
        {disable: false, id: 18, label: '须弥—阿陀河谷', price: 70},
        {disable: false, id: 19, label: '须弥—道成林', price: 60},
        {disable: false, id: 20, label: '须弥—二净甸', price: 50},
        {disable: false, id: 21, label: '须弥—失梦的苗圃', price: 15},
        {disable: false, id: 22, label: '须弥—桓那兰那', price: 15},
        {disable: false, id: 23, label: '须弥—上风蚀地', price: 40},
        {disable: false, id: 24, label: '须弥—下风蚀地', price: 80},
        {disable: false, id: 25, label: '须弥—列柱沙原', price: 100},
        {disable: false, id: 30, label: '须弥—千壑沙地', price: 170},
        {disable: false, id: 31, label: '须弥—荒石苍漠（不含该地区满神瞳和甘露池）', price: 90},
        {disable: false, id: 32, label: '须弥—浮罗囿 （不含该地区满神瞳和甘露池）', price: 80},
        {disable: false, id: 33, label: '雪山（含绯红玉髓8级）', price: 120},
        {disable: false, id: 34, label: '雪山全宝箱（含8级绯红玉髓）', price: 188},
        {disable: false, id: 27, label: '渊下宫', price: 120},
        {disable: false, id: 28, label: '层岩上 ', price: 60},
        {disable: false, id: 29, label: '层岩下 ', price: 80},
        {disable: false, id: 35, label: '枫丹—白露区', price: 60},
        {disable: false, id: 36, label: '枫丹—苍晶区', price: 120},
        {disable: false, id: 37, label: '枫丹—枫丹廷区 ', price: 150},

      ],
      //地图探索 -- 地图套餐
      mapsComboList: [
        {
          text: '蒙德套餐（含满风神瞳）—明冠山地+坠星山谷+苍风高地+风啸山坡（不保证全宝箱）', price: 170, checked: false, id: 1,
          associate: [1, 2, 3, 4]
        },
        {
          text: '璃月套餐（含满岩神瞳）—珉林+碧水原+琼玑野+云来海+璃沙郊（不保证全宝箱）', price: 335, checked: false, id: 2,
          associate: [5, 6, 7, 8, 9]
        },
        {
          text: '稻妻套餐（含满雷神瞳）—鸣神岛+神无冢+八酝岛+海祈岛+清赖岛+鹤观（不保证全宝箱）', price: 350, checked: false, id: 3,
          associate: [10, 11, 12, 13, 14, 15]
        },
        {
          text: '须弥雨林套餐（含雨林110颗草神瞳）—善见地+护世森+阿陀河谷+道成林+二净甸+失梦的苗圃和桓那兰那（不保证全宝箱）', price: 300, checked: false, id: 4,
          associate: [16, 17, 18, 19, 20, 21, 22]
        },
        {
          text: '须弥沙漠套餐（含沙漠70颗草神瞳）—上风蚀地+下风蚀地+列柱沙原（不保证全宝箱）', price: 200, checked: false, id: 5,
          associate: [23, 24, 25]
        },
        {
          text: '须弥—千壑沙地套餐（含55颗草神瞳）', price: 200, checked: false, id: 13,
          // associate: [30]
          associate: []
        },
        {
          text: '须弥—荒石苍漠/浮罗囿套餐（含36颗草神瞳以及甘露池满级）', price: 220, checked: false, id: 14,
          // associate: [31, 32]
          associate: []
        },
        {
          text: '全须弥套餐（雨林+沙漠+千壑沙地+荒石苍漠+浮罗囿）', price: 900, checked: false, id: 15,
          // associate: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 30, 31, 32]
          associate: []
        },
        // {
        //   text: '须弥雨林+须弥沙漠套餐（含180颗草神瞳）', price: 480, checked: false, id: 6,
        //   associate: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
        // },
        {
          text: '蒙德全宝箱：（默认偏差10个以内）', price: 300, checked: false, id: 7,
          associate: [1, 2, 3, 4]
        },
        {
          text: '稻妻全宝箱：（默认偏差10个以内）', price: 588, checked: false, id: 8,
          associate: [10, 11, 12, 13, 14, 15]
        },
        {
          text: '渊下宫全宝箱：（默认偏差5个以内）', price: 188, checked: false, id: 9,
          associate: [27]
        },
        {
          text: '层岩上下宝箱：（默认偏差5个以内）', price: 188, checked: false, id: 10,
          associate: [28, 29]
        },
        {
          text: '须弥3.0宝箱雨林：（默认偏差10个以内）', price: 433, checked: false, id: 11,
          associate: [16, 17, 18, 19, 20, 21, 22]
        },
        {
          text: '须弥3.1宝箱沙漠：（默认偏差5个以内）', price: 350, checked: false, id: 12,
          associate: [23, 24, 25]
        },
        {
          text: '千壑沙地全宝箱（默认偏差5个以内）', price: 260, checked: false, id: 16,
          associate: []
        },
        {
          text: '须弥—荒石苍漠/浮罗囿全宝箱（默认偏差5个以内）', price: 260, checked: false, id: 17,
          associate: []
        },
        {
          text: '枫丹4.0全宝箱（含85颗神瞳）（默认偏差5个以内）', price: 360, checked: false, id: 18,
          associate: []
        },
      ],
      //材料其他
      materialList: [
        {price: 0.15, list: ['霓裳花', '风车菊', '绝云椒椒', '白铁矿', '黑铁矿', '蓝水晶矿', '紫水晶矿', '魔晶矿', '星银矿']},
        {
          price: 0.2, list: ['圣金虫', '月莲', '星螺', '海灵芝', '珊瑚真珠', '天云草实',
            '蒲公英籽', '鸣草', '慕风蘑菇', '血斛', '塞西莉亚花', '小灯草',
            '琉璃百合', '幽灯蕈', '夜泊石', '帕蒂莎兰', '绯樱绣球', '鬼兜虫',
            '石珀', '清心', '琉璃袋', '赤念果', '劫波莲', '晶化骨髓',
            '树王圣体菇', '落落莓', '嘟嘟莲', '钩钩果','塞西莉亚花','沙脂蛹','悼灵花','虹彩蔷薇','柔灯玲']
        },
        {
          price: 0.15, list: ['黯淡棱镜', '晦暗刻像', '导能绘卷', '蕈兽孢子', '骗骗花蜜'
            , '寻宝鸦印', '褪色红绸', '失活菌核', '沉重号角', '混沌装置'
            , '混沌容器', '混沌机关', '雾虚花粉', '猎兵祭刀',
            '破缺棱晶', '新兵的徽记', '史莱姆凝液',
            '地脉的旧枝', '脆弱的骨片','残毁的横脊','来自何处的待放之花','啮合齿轮','异海凝珠','浊水的一滴'
          ], tip: '(世界等级3以上)'
        },
        {
          price: 0.3, list: ['水晶棱镜', '夤夜刻像', '封魔绘卷', '荧光孢粉', '微光花蜜'
            , '史莱姆清', '藏银鸦印', '镶边红绸', '休眠菌核', '黑铜号角'
            , '混沌回路', '混沌模块', '混沌枢纽', '雾虚草囊', '特工祭刀'
            , '混浊棱晶', '士官的徽记',  '地脉的枯叶'
            , '结实的骨片','密固的横脊','何人所珍藏之花','机关正齿轮','异海之块','浊水的一掬'
          ], tip: '(世界等级5以上)'
        },
        {
          price: 0.65, list: ['偏光棱镜', '幽邃刻像', '禁咒绘卷', '孢囊晶尘', '原素花蜜'
            , '攫金鸦印', '织金红绸', '茁壮菌核', '黑晶号角', '混沌炉心'
            , '混沌锚栓', '混沌真眼', '雾虚灯芯', '辉光棱晶', '尉官的徽记'
            , '史莱姆原浆',  '地脉的新芽', '石化的骨片'
            , '督察长祭刀','锲纹的横脊','漫游者的盛放之花','奇械机芯齿轮','异色结晶石','初生的浊水幻灵'
          ], tip: '(世界等级7以上)'
        },
      ],
      //采集材料 -- 其他
      rareMaterialList: [
        {label: '晶蝶', price: 12, company: '100个'},
        {label: '黑铁矿', price: 5, company: '100个'},
        {label: '鱼叉本体', price: 35, company: '个'},
        {label: '鱼叉精炼', price: 12, company: '次'},
        {label: '鱼弓本体', price: 30, company: '个'},
        {label: '鱼弓精炼', price: 8, company: '次'},
      ],
      //打怪材料 -- 稻妻特殊材料
      rareMaterialList1: [
        {label: '破旧的刀镡', price: 0.25, company: '个'},
        {label: '影打刀镡', price: 0.6, company: '个'},
        {label: '名刀镡', price: 1, company: '个'},
        {label: '隐兽指爪', price: 0.2, company: '个'},
        {label: '隐兽利爪', price: 0.35, company: '个'},
        {label: '隐兽鬼爪', price: 0.65, company: '个'},
        {label: '浮游干核', price: 0.15, company: '个'},
        {label: '浮游幽核', price: 0.3, company: '个'},
        {label: '浮游晶化核', price: 0.6, company: '个'},
      ],
      //打怪材料 -- 丘丘人低掉落材料
      rareMaterialList2:[
        {label: '破旧的面具', price: 0.25, company: '个'},
        {label: '污秽的面具', price: 0.6, company: '个'},
        {label: '不祥的面具', price: 1, company: '个'},
        {label: '牢固的箭簇', price: 0.25, company: '个'},
        {label: '锐利的箭簇', price: 0.6, company: '个'},
        {label: '历战的箭簇', price: 1, company: '个'},
      ],
      //树类等级提升 -- 套餐
      treeComboList: [
        {text: '绯红玉髓忍冬树8级', price: 40, checked: false},
        {text: '忍冬树8-12级', price: 30, checked: false},
      ],
      treeComboListDis: false,
      //任务类
      taskClassList: [
        {label: '魔神任务：25~40r/幕（任务按耗费时间决定）', price: 0},
        // {label: '魔神任务至须弥第四幕：25r/幕', price: 25},
        // {label: '魔神任务须弥第五幕：40r/幕', price: 40},
        {label: '传说任务/邀约任务：15r/个', price: 15},
        {label: '世界任务：6~80r（任务按耗费时间决定）', price: 0},
        {label: '蒙德锚点：20r', price: 20},
        {label: '璃月锚点：35r', price: 35},
        {label: '须弥雨林锚点（不包括隐藏锚点）：25r', price: 25},
        {label: '须弥沙漠锚点（不包括隐藏锚点）：20r', price: 20},
        {label: '须弥千壑沙地锚点（不包括隐藏锚点）：15r', price: 15},
        {label: '须弥—荒石苍漠/浮罗囿锚点（不包括隐藏锚点）：20r', price: 20},
        {label: '枫丹4.0锚点（不包括隐藏锚点）：40r', price: 40},
      ],
      //角色/武器突破
      breachClassList: [
        // {label: '1-50级', price: 50},
        // {label: '50-70级', price: 30},
        // {label: '70-90级', price: 40},
        {label: '20-40级（不包含经验书和摩拉）', price: 8},
        {label: '40-50级（不包含经验书和摩拉）', price: 12},
        {label: '50-60级（不包含经验书和摩拉）', price: 16},
        {label: '60-70级（不包含经验书和摩拉）', price: 23},
        {label: '70-80级（不包含经验书和摩拉）', price: 30},
        {label: '80-90级（不包含经验书和摩拉）', price: 50},
        {label: '角色小毕业', price: 450},
        {label: '圣遗物小毕业', price: 350},
      ],
      //冒险等级任务类 套餐
      adventureLevelCombo: [
        {label: '1-5级', price: 20, speed: 'fast', timeText: '（45分钟以内）', disable: false},
        {label: '5-10级', price: 40, speed: 'fast', timeText: '（一个小时内）', disable: false},
        {label: '10-15级', price: 60, speed: 'fast', timeText: '（两个小时内）', disable: false},
        {label: '15-20级', price: 100, speed: 'fast', timeText: '（三个小时内）', disable: false},
        {label: '20-25级', price: 188, speed: 'fast', timeText: '（五个小时内）', disable: false},
        {label: '25-30级', price: 238, speed: 'fast', timeText: '（12个小时内）', disable: false},
        {label: '30-35级', price: 288, speed: 'fast', timeText: '（14个小时内）', disable: false},
        {label: '35-40级', price: 328, speed: 'fast', timeText: '（一天内）', disable: false},
        {label: '40-45级', price: 520, speed: 'fast', timeText: '（两天内）', disable: false},
        // {label: '1-5级', price: 7, speed: 'low', timeText: '（3小时内）', disable: false},
        // {label: '5-10级', price: 10, speed: 'low', timeText: '（3小时内）', disable: false},
        // {label: '10-15级', price: 15, speed: 'low', timeText: '（12小时）', disable: false},
        // {label: '15-20级', price: 30, speed: 'low', timeText: '（18小时）', disable: false},
        // {label: '20-25级', price: 45, speed: 'low', timeText: '（一天）', disable: false},
        // {label: '25-30级', price: 75, speed: 'low', timeText: '（一天半）', disable: false},
        // {label: '30-35级', price: 125, speed: 'low', timeText: '（两天）', disable: false},
        // {label: '35-40级', price: 200, speed: 'low', timeText: '（三天）', disable: false},
        // {label: '40-45级', price: 300, speed: 'low', timeText: '（五天）', disable: false},
      ],
      //冒险等级任务类
      adventureLevelList: [
        // {text: '等级套餐：1-20', priceText: '（单价：8.88r/级）', price: 8.88, gap: '96'},
        // {text: '等级套餐：20-25', priceText: '（单价：15r/级）', price: 15, gap: '100'},
        // {text: '等级套餐：25-30', priceText: '（单价：20r/级）', price: 20, gap: '100'},
        // {text: '等级套餐：30-35', priceText: '（单价：30r/级）', price: 30, gap: '100'},
        // {text: '等级套餐：35-40', priceText: '（单价：50r/级）', price: 50, gap: '100'},
        {text: '等级套餐：45-50', priceText: '（起步80R 每一级递增5R  (15天) ）', price: 80, gap: '264'},
        {text: '等级套餐：50-55', priceText: '（起步150R 每一级递增50R（两个月））', price: 150, gap: '223'},
        {text: '等级套餐：55-60', priceText: '（起步1000R 每一级递增500R（时间不限打完为止，送每天日体）)', price: 1000, gap: '64'},
      ],
      adventureLevelTotalList: [],
      //表单
      form: {
        //日常委托
        dailyCommission: {
          //日常体力不指定boss
          dailyStamina: {val: '', price: ''},
          //日常体力指定boss
          dailyStaminaBoss: {val: '', price: ''},
          //日常委托
          dailyCommission: {val: '', price: ''},
          //捡圣遗物狗粮
          dogFood: {val: '', price: ''},
          //体委
          sportsCommittee: {val: '', price: 399},
          //精托
          sperReceptacle: {val: '', price: 680},
          //秘境
          unchartedBoss: {val: '', price: 2},
          //纪行
          chronicle: {val: '', price: 60},
          //套餐
          comob: {
            comob0: {val: '', price: ''},
            comob1: {val: '', price: ''},
            comob2: {val: '', price: ''},
            comob3: {val: '', price: ''},
            comob4: {val: '', price: ''},
          },
          //突破等级
          levelUp: [],
          //总计
          total: ''
        },
        dailyCommissionTotal: 0,
        //神通类
        supernatural: [],
        supernaturalTotal: 0,
        //地图探索
        mapExploration: {
          //地图
          maps: [],
          //探索度 80-90
          degreeOfExpMin1: '',
          degreeOfExpMax1: '',
          //探索度 90-100
          degreeOfExpMin2: '',
          degreeOfExpMax2: '',
          //地图套餐
          mapsList: []
        },
        mapExplorationTotal: 0,
        //材料其他
        materialOther: {
          //采集材料
          materialList0: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
          },
          materialList1: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
            material21: '',
            material22: '',
            material23: '',
            material24: '',
            material25: '',
            material26: '',
            material27: '',
          },
          //打怪材料
          materialList2: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
            material21: '',
          },
          materialList3: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
          },
          materialList4: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
            material21: '',
          },
          rareMaterial: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
          },
          rareMaterial1: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
          },
          rareMaterial2: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
          }
        },
        materialOtherTotal: 0,
        //树类等级提升
        sakuraTree: {
          // 1-30
          treeLevelMin1: '',
          treeLevelMax1: '',
          // 30-40
          treeLevelMax2: '',
          treeLevelMin2: '',
          // 40-50
          treeLevelMax3: '',
          treeLevelMin3: '',
          // 梦之树 1-10
          treeLevelMax4: '',
          treeLevelMin4: '',
          // 梦之树 10-20
          treeLevelMax5: '',
          treeLevelMin5: '',
          // 梦之树 20-30
          treeLevelMax6: '',
          treeLevelMin6: '',
          // 梦之树 30-40
          treeLevelMax7: '',
          treeLevelMin7: '',
          // 梦之树 40-45
          treeLevelMax8: '',
          treeLevelMin8: '',
          // 梦之树 45-50
          treeLevelMax9: '',
          treeLevelMin9: '',
          // 露景泉 1-10
          treeLevelMax10: '',
          treeLevelMin10: '',
          // 露景泉 10-20
          treeLevelMax11: '',
          treeLevelMin11: '',
          // 套餐
          treeCombo: []
        },
        sakuraTreeTotal: 0,
        //任务类
        taskClass: [],
        taskClassTotal: 0,
        //角色/武器突破
        breachClass: [],
        breachClassTotal: 0,
        //冒险等级任务类
        adventureLevel: {
          // adventureLevelMin0: '',
          // adventureLevelMax0: '',
          // adventureLevelMin1: '',
          // adventureLevelMax1: '',
          // adventureLevelMin2: '',
          // adventureLevelMax2: '',
          // adventureLevelMin3: '',
          // adventureLevelMax3: '',
          adventureLevelMin4: '',
          adventureLevelMax4: '',
          adventureLevelMin5: '',
          adventureLevelMax5: '',
          adventureLevelMin6: '',
          adventureLevelMax6: '',
          adventureCombo: [],
        },
        adventureLevelTotal: 0,
        //自定义
        customize: '',
        //备注
        remark: ''
      },
      //文本
      textarea: '',
      total: 0

    }
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        //日常委托
        dailyCommission: {
          //日常体力不指定boss
          dailyStamina: {val: '', price: ''},
          //日常体力指定boss
          dailyStaminaBoss: {val: '', price: ''},
          //日常委托
          dailyCommission: {val: '', price: ''},
          //捡圣遗物狗粮
          dogFood: {val: '', price: ''},
          //体委
          sportsCommittee: {val: '', price: 399},
          //精托
          sperReceptacle: {val: '', price: 680},
          //秘境
          unchartedBoss: {val: '', price: 2},
          //纪行
          chronicle: {val: '', price: 60},
          //套餐
          comob: {
            comob0: {val: '', price: ''},
            comob1: {val: '', price: ''},
            comob2: {val: '', price: ''},
            comob3: {val: '', price: ''},
            comob4: {val: '', price: ''},
          },
          //突破等级
          levelUp: [],
          //总计
          total: ''
        },
        dailyCommissionTotal: 0,
        //神通类
        supernatural: [],
        supernaturalTotal: 0,
        //地图探索
        mapExploration: {
          //地图
          maps: [],
          //探索度 80-90
          degreeOfExpMin1: '',
          degreeOfExpMax1: '',
          //探索度 90-100
          degreeOfExpMin2: '',
          degreeOfExpMax2: '',
          //地图套餐
          mapsList: []
        },
        mapExplorationTotal: 0,
        //材料其他
        materialOther: {
          //采集材料
          materialList0: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
          },
          materialList1: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
            material21: '',
            material22: '',
            material23: '',
            material24: '',
            material25: '',
            material26: '',
            material27: '',
          },
          //打怪材料
          materialList2: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
            material21: '',
          },
          materialList3: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
          },
          materialList4: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
            material9: '',
            material10: '',
            material11: '',
            material12: '',
            material13: '',
            material14: '',
            material15: '',
            material16: '',
            material17: '',
            material18: '',
            material19: '',
            material20: '',
            material21: '',
          },
          rareMaterial: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
          },
          rareMaterial1: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
            material6: '',
            material7: '',
            material8: '',
          },
          rareMaterial2: {
            material0: '',
            material1: '',
            material2: '',
            material3: '',
            material4: '',
            material5: '',
          },
        },
        materialOtherTotal: 0,
        //树类等级提升
        sakuraTree: {
          // 1-30
          treeLevelMin1: '',
          treeLevelMax1: '',
          // 30-40
          treeLevelMax2: '',
          treeLevelMin2: '',
          // 40-50
          treeLevelMax3: '',
          treeLevelMin3: '',
          // 梦之树 1-10
          treeLevelMax4: '',
          treeLevelMin4: '',
          // 梦之树 10-20
          treeLevelMax5: '',
          treeLevelMin5: '',
          // 梦之树 20-30
          treeLevelMax6: '',
          treeLevelMin6: '',
          // 梦之树 30-40
          treeLevelMax7: '',
          treeLevelMin7: '',
          // 梦之树 40-45
          treeLevelMax8: '',
          treeLevelMin8: '',
          // 梦之树 45-50
          treeLevelMax9: '',
          treeLevelMin9: '',
          // 露景泉 1-10
          treeLevelMax10: '',
          treeLevelMin10: '',
          // 露景泉 10-20
          treeLevelMax11: '',
          treeLevelMin11: '',
          // 套餐
          treeCombo: []
        },
        sakuraTreeTotal: 0,
        //任务类
        taskClass: [],
        taskClassTotal: 0,
        //角色/武器突破
        breachClass: [],
        breachClassTotal: 0,
        //冒险等级任务类
        adventureLevel: {
          // adventureLevelMin0: '',
          // adventureLevelMax0: '',
          // adventureLevelMin1: '',
          // adventureLevelMax1: '',
          // adventureLevelMin2: '',
          // adventureLevelMax2: '',
          // adventureLevelMin3: '',
          // adventureLevelMax3: '',
          adventureLevelMin4: '',
          adventureLevelMax4: '',
          adventureLevelMin5: '',
          adventureLevelMax5: '',
          adventureLevelMin6: '',
          adventureLevelMax6: '',
          adventureCombo: [],
        },
        adventureLevelTotal: 0,
        //自定义
        customize: '',
        //备注
        remark: ''
      }
      this.textarea = ''
      this.total = 0
      this.treeComboListDis = false
      this.adventureLevelTotalList = []
      this.resetFormShow = false
      this.supernaturalList = this.supernaturalList.map((it) => {
        it.disable = false;
        return it
      })
      this.mapsList = this.mapsList.map((it) => {
        it.disable = false;
        return it
      })
      this.mapsComboList = this.mapsComboList.map((it) => {
        it.checked = false;
        return it
      })
      this.treeComboList = this.treeComboList.map((it) => {
        it.checked = false;
        return it
      })
      this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
        it.disable = false;
        return it
      })
    },

    /**
     * 日常委托 套餐选择
     * @param index 套餐下标
     */
    DCcomobInputChange(index) {
      for (let comobKey in this.form.dailyCommission.comob) {
        if (`comob${index}` !== comobKey) {
          this.form.dailyCommission.comob[comobKey] = {val: '', price: ''}
        }
      }
    },
    /**
     * 日常委托 突破等级
     * @param item 选中项
     */
    levelUpChange(item) {
      if (!this.form.dailyCommission.levelUp.includes(item)) {
        this.form.dailyCommission.levelUp.push(item)
      } else {
        this.form.dailyCommission.levelUp.splice(this.form.dailyCommission.levelUp.indexOf(item), 1)
      }
    },
    /**
     * 神通类
     * @param item 选中项
     */
    supernaturalChange(item) {
      if (item.disable) {
        return
      }
      if (!this.form.supernatural.includes(item)) {
        this.form.supernatural.push(item)
        if (item.id === 6) {
          if (this.form.supernatural.findIndex(val => val.id === 5) > -1) {
            this.form.supernatural.splice(this.form.supernatural.findIndex(val => val.id === 5), 1)
          }
          if (this.form.supernatural.findIndex(val => val.id === 4) > -1) {
            this.form.supernatural.splice(this.form.supernatural.findIndex(val => val.id === 4), 1)
          }
        }
        if (item.id === 4 || item.id === 5) {
          if (this.form.supernatural.findIndex(val => val.id === 6) > -1) {
            this.form.supernatural.splice(this.form.supernatural.findIndex(val => val.id === 6), 1)
          }
        }
      } else {
        this.form.supernatural.splice(this.form.supernatural.indexOf(item), 1)
      }
    },
    /**
     * 地图探索 地图
     * @param item
     */
    mapslChange(item) {
      if (item.disable) {
        return
      }
      if (!this.form.mapExploration.maps.includes(item)) {
        this.form.mapExploration.maps.push(item)
      } else {
        this.form.mapExploration.maps.splice(this.form.mapExploration.maps.indexOf(item), 1)
      }
    },
    /**
     * 地图探索 探索度
     */
    degreeOfExpChange(item, val) {
      if (!val) {
        this.form.mapExploration[item] = val
      } else {
        val = val * 1
        if (item === 'degreeOfExpMin1' || item === 'degreeOfExpMax1') {
          this.form.mapExploration[item] = val < 80 ? 80 : val > 90 ? 90 : val
        } else {
          this.form.mapExploration[item] = val < 90 ? 90 : val > 100 ? 100 : val
        }
      }
      if (this.form.mapExploration.degreeOfExpMax1 <= this.form.mapExploration.degreeOfExpMin1) this.form.mapExploration.degreeOfExpMax1 = ''
      if (this.form.mapExploration.degreeOfExpMax2 <= this.form.mapExploration.degreeOfExpMin2) this.form.mapExploration.degreeOfExpMax2 = ''
      if (this.form.mapExploration.degreeOfExpMin1 === '') this.form.mapExploration.degreeOfExpMax1 = ''
      if (this.form.mapExploration.degreeOfExpMin2 === '') this.form.mapExploration.degreeOfExpMax2 = ''
    },
    /**
     * 地图探索 多选禁用
     */
    mapExplorationMapsDis(item, bool) {
      item.associate.forEach((items, index) => {
        if (this.mapsList.findIndex(val => val.id === items) > -1) {
          this.mapsList[this.mapsList.findIndex(val => val.id === items)].disable = bool
        }
      })
    },
    /**
     * 地图探索 套餐 反选神瞳类
     */
    mapsComboChangeSupernatural(id, bool) {
      this.form.supernatural = this.form.supernatural.filter(val => !this.supernaturalList[this.supernaturalList.findIndex(val => val.id === id)].associate.includes(val.id))
      if (id === 1 || id === 2 || id === 3) {
        this.supernaturalList[this.supernaturalList.findIndex(val => val.id === id)].disable = bool
      } else if (id === 4 || id === 5) {
        this.supernaturalList[this.supernaturalList.findIndex(val => val.id === (id === 4 ? 5 : 4))].disable = bool
        if (this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 4)].disable || this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 5)].disable) {
          this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 6)].disable = true
        } else if (!this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 4)].disable && !this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 5)].disable) {
          this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 6)].disable = false
        }
      } else if (id === 6) {
        this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 4)].disable = bool
        this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 5)].disable = bool
        this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 6)].disable = bool
      } else if (id === 7 || id === 8) {
        if (id === 7) {
          this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 1)].disable = bool
        } else if (id === 8) {
          this.supernaturalList[this.supernaturalList.findIndex(val => val.id === 3)].disable = bool
        }
      }
    },
    /**
     * 地图探索 套餐
     */
    mapsComboChange(item, index) {
      if (item.checked) {
        if (item.id === 1 || item.id === 2 || item.id === 3) {
          this.mapsComboChangeSupernatural(item.id, item.checked)
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 7) > -1 && item.id === 1) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 7)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 8) > -1 && item.id === 3) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 8)].checked = false
          }
        } else if (item.id === 4 || item.id === 5 || item.id === 7 || item.id === 8) {
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 6) > -1 && (item.id === 4 || item.id === 5)) {
            this.mapExplorationMapsDis(this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 6)], false)
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 6)].checked = false
            this.mapsComboChangeSupernatural(6, false)
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 11) > -1 && item.id === 4) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 11)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 12) > -1 && item.id === 5) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 12)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 1) > -1 && item.id === 7) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 1)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 3) > -1 && item.id === 8) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 3)].checked = false
          }
          if (item.id === 4 || item.id === 5) {
            this.mapsComboChangeSupernatural(item.id, item.checked)
          }
        } else if (item.id === 6) {
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 4) > -1) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 4)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 5) > -1) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 5)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 11) > -1) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 11)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 12) > -1) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 12)].checked = false
          }
          this.mapsComboChangeSupernatural(item.id, item.checked)
        } else if (item.id === 11 || item.id === 12) {
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 6) > -1) {
            this.mapExplorationMapsDis(this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 6)], false)
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 6)].checked = false
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 4) > -1 && item.id === 11) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 4)].checked = false
            this.mapsComboChangeSupernatural(4, false)
          }
          if (this.form.mapExploration.mapsList.findIndex(val => val.id === 5) > -1 && item.id === 12) {
            this.form.mapExploration.mapsList[this.form.mapExploration.mapsList.findIndex(val => val.id === 5)].checked = false
            this.mapsComboChangeSupernatural(5, false)
          }
        }
        this.form.mapExploration.maps = this.form.mapExploration.maps.filter(val => !item.associate.includes(val.id))
      }
      this.mapsComboChangeSupernatural(item.id, item.checked)
      this.mapExplorationMapsDis(item, item.checked)
      if (item.id === 7 || item.id === 8) {
        this.mapsComboChangeSupernatural(item.id, false)
      }
      this.form.mapExploration.mapsList = this.mapsComboList.filter(val => {
        return val.checked
      })
    },
    /**
     * 树类等级提升 等级
     */
    treeLevelChange(item, val) {
      if (!val) {
        this.form.sakuraTree[item] = val
      } else {
        val = val * 1
        if (item === 'treeLevelMin1' || item === 'treeLevelMax1') {
          this.form.sakuraTree[item] = val < 1 ? 1 : val > 30 ? 30 : val
        } else if (item === 'treeLevelMin2' || item === 'treeLevelMax2') {
          this.form.sakuraTree[item] = val < 30 ? 30 : val > 40 ? 40 : val
        } else if (item === 'treeLevelMin3' || item === 'treeLevelMax3') {
          this.form.sakuraTree[item] = val < 40 ? 40 : val > 50 ? 50 : val
        } else if (item === 'treeLevelMin4' || item === 'treeLevelMax4') {
          this.form.sakuraTree[item] = val < 1 ? 1 : val > 10 ? 10 : val
        } else if (item === 'treeLevelMin5' || item === 'treeLevelMax5') {
          this.form.sakuraTree[item] = val < 10 ? 10 : val > 20 ? 20 : val
        } else if (item === 'treeLevelMin6' || item === 'treeLevelMax6') {
          this.form.sakuraTree[item] = val < 20 ? 20 : val > 30 ? 30 : val
        } else if (item === 'treeLevelMin7' || item === 'treeLevelMax7') {
          this.form.sakuraTree[item] = val < 30 ? 30 : val > 40 ? 40 : val
        } else if (item === 'treeLevelMin8' || item === 'treeLevelMax8') {
          this.form.sakuraTree[item] = val < 40 ? 40 : val > 45 ? 45 : val
        } else if (item === 'treeLevelMin9' || item === 'treeLevelMax9') {
          this.form.sakuraTree[item] = val < 45 ? 45 : val > 50 ? 50 : val
        } else if (item === 'treeLevelMin10' || item === 'treeLevelMax10') {
          this.form.sakuraTree[item] = val < 1 ? 1 : val > 10 ? 10 : val
        } else if (item === 'treeLevelMin11' || item === 'treeLevelMax11') {
          this.form.sakuraTree[item] = val < 10 ? 10 : val > 20 ? 20 : val
        }
      }
      if (this.form.sakuraTree.treeLevelMax1 <= this.form.sakuraTree.treeLevelMin1) this.form.sakuraTree.treeLevelMax1 = ''
      if (this.form.sakuraTree.treeLevelMin1 === '') this.form.sakuraTree.treeLevelMax1 = ''
      if (this.form.sakuraTree.treeLevelMax2 <= this.form.sakuraTree.treeLevelMin2) this.form.sakuraTree.treeLevelMax2 = ''
      if (this.form.sakuraTree.treeLevelMin2 === '') this.form.sakuraTree.treeLevelMax2 = ''
      if (this.form.sakuraTree.treeLevelMax3 <= this.form.sakuraTree.treeLevelMin3) this.form.sakuraTree.treeLevelMax3 = ''
      if (this.form.sakuraTree.treeLevelMin3 === '') this.form.sakuraTree.treeLevelMax3 = ''
      if (this.form.sakuraTree.treeLevelMax4 <= this.form.sakuraTree.treeLevelMin4) this.form.sakuraTree.treeLevelMax4 = ''
      if (this.form.sakuraTree.treeLevelMin4 === '') this.form.sakuraTree.treeLevelMax4 = ''
      if (this.form.sakuraTree.treeLevelMax5 <= this.form.sakuraTree.treeLevelMin5) this.form.sakuraTree.treeLevelMax5 = ''
      if (this.form.sakuraTree.treeLevelMin5 === '') this.form.sakuraTree.treeLevelMax5 = ''
      if (this.form.sakuraTree.treeLevelMax6 <= this.form.sakuraTree.treeLevelMin6) this.form.sakuraTree.treeLevelMax6 = ''
      if (this.form.sakuraTree.treeLevelMin6 === '') this.form.sakuraTree.treeLevelMax6 = ''
      if (this.form.sakuraTree.treeLevelMax7 <= this.form.sakuraTree.treeLevelMin7) this.form.sakuraTree.treeLevelMax7 = ''
      if (this.form.sakuraTree.treeLevelMin7 === '') this.form.sakuraTree.treeLevelMax7 = ''
      if (this.form.sakuraTree.treeLevelMax8 <= this.form.sakuraTree.treeLevelMin8) this.form.sakuraTree.treeLevelMax8 = ''
      if (this.form.sakuraTree.treeLevelMin8 === '') this.form.sakuraTree.treeLevelMax8 = ''
      if (this.form.sakuraTree.treeLevelMax9 <= this.form.sakuraTree.treeLevelMin9) this.form.sakuraTree.treeLevelMax9 = ''
      if (this.form.sakuraTree.treeLevelMin9 === '') this.form.sakuraTree.treeLevelMax9 = ''
      if (this.form.sakuraTree.treeLevelMax10 <= this.form.sakuraTree.treeLevelMin10) this.form.sakuraTree.treeLevelMax10 = ''
      if (this.form.sakuraTree.treeLevelMin10 === '') this.form.sakuraTree.treeLevelMax10 = ''
      if (this.form.sakuraTree.treeLevelMax11 <= this.form.sakuraTree.treeLevelMin11) this.form.sakuraTree.treeLevelMax11 = ''
      if (this.form.sakuraTree.treeLevelMin11 === '') this.form.sakuraTree.treeLevelMax11 = ''
      /*      if ((this.form.sakuraTree.treeLevelMax1 && this.form.sakuraTree.treeLevelMin1) || (this.form.sakuraTree.treeLevelMax2 && this.form.sakuraTree.treeLevelMin2)
              || (this.form.sakuraTree.treeLevelMax3 && this.form.sakuraTree.treeLevelMin3) || (this.form.sakuraTree.treeLevelMax4 && this.form.sakuraTree.treeLevelMin4)) {
              this.treeComboListDis = true
              this.form.sakuraTree.treeCombo = []
              this.treeComboList.forEach(items => {
                items.checked = false
              })
            } else {
              this.treeComboListDis = false
            }*/
    },
    /*    /!**
         * 树类等级提升 套餐
         * @param item 选中项
         *!/
        treeComboChange(item) {
          this.form.sakuraTree.treeLevelMin1 = ''
          this.form.sakuraTree.treeLevelMax1 = ''
          this.form.sakuraTree.treeLevelMax2 = ''
          this.form.sakuraTree.treeLevelMin2 = ''
          this.form.sakuraTree.treeLevelMax3 = ''
          this.form.sakuraTree.treeLevelMin3 = ''
          this.form.sakuraTree.treeLevelMax4 = ''
          this.form.sakuraTree.treeLevelMin4 = ''
          if (this.form.sakuraTree.treeCombo === item) {
            this.form.sakuraTree.treeCombo = {}
          } else {
            for (let sakuraTreeKey in this.form.sakuraTree) {
              if (this.form.sakuraTree[sakuraTreeKey] !== 'treeCombo') {
                this.form.sakuraTree[sakuraTreeKey] = ''
              }
            }
            this.form.sakuraTree.treeCombo = item
          }
          this.treeComboList.forEach(items => {
            if (items !== item) {
              items.checked = false
            }
          })
        },*/
    /**
     * 地图探索 地图
     * @param item
     */
    treeComboChange(item) {
      if (item.disable) {
        return
      }
      if (!this.form.sakuraTree.treeCombo.includes(item)) {
        this.form.sakuraTree.treeCombo.push(item)
      } else {
        this.form.sakuraTree.treeCombo.splice(this.form.sakuraTree.treeCombo.indexOf(item), 1)
      }
    },
    /**
     * 任务类
     * @param item 选中项
     */
    taskClassChange(item) {
      if (!this.form.taskClass.includes(item)) {
        this.form.taskClass.push(item)
      } else {
        this.form.taskClass.splice(this.form.taskClass.indexOf(item), 1)
      }
    },
    /**
     * 角色/武器突破
     * @param item 选中项
     */
    breachClassChange(item) {
      if (!this.form.breachClass.includes(item)) {
        this.form.breachClass.push(item)
      } else {
        this.form.breachClass.splice(this.form.breachClass.indexOf(item), 1)
      }
    },
    /**
     * 冒险等级任务类 套餐
     * @param item 选中项
     */
    adventureLevelComboChange(item) {
      if (item.disable) {
        return
      }
      if (item.speed === 'fast' && this.form.adventureLevel.adventureCombo.length === 0) {
        // this.adventureLevelCombo = this.adventureLevelCombo.filter(val => val.disable = val.speed === 'low'?true:false)
        this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
          if (it.speed === 'low') it.disable = !it.disable;
          return it
        })
      } else if (item.speed === 'low' && this.form.adventureLevel.adventureCombo.length === 0) {
        this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
          if (it.speed === 'fast') it.disable = !it.disable;
          return it
        })
      }
      if (!this.form.adventureLevel.adventureCombo.includes(item)) {
        this.form.adventureLevel.adventureCombo.push(item)
      } else {
        this.form.adventureLevel.adventureCombo.splice(this.form.adventureLevel.adventureCombo.indexOf(item), 1)
        if (this.form.adventureLevel.adventureCombo.length === 0) {
          this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
            if (it.speed === 'fast') it.disable = false;
            return it
          })
          this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
            if (it.speed === 'low') it.disable = false;
            return it
          })
        }
      }

    },
    /**
     * 冒险等级任务类
     * @param item
     * @param val
     */
    adventureLevelChange(item, val) {
      if (!val) {
        this.form.adventureLevel[item] = val
      } else {
        val = val * 1
        switch (item) {
          /*          case 'adventureLevelMin0':
                    case 'adventureLevelMax0':
                      this.form.adventureLevel[item] = val < 20 ? 20 : val > 25 ? 25 : val
                      break;
                    case 'adventureLevelMin1':
                    case 'adventureLevelMax1':
                      this.form.adventureLevel[item] = val < 25 ? 25 : val > 30 ? 30 : val
                      break;
                    case 'adventureLevelMin2':
                    case 'adventureLevelMax2':
                      this.form.adventureLevel[item] = val < 30 ? 30 : val > 35 ? 35 : val
                      break;
                    case 'adventureLevelMin3':
                    case 'adventureLevelMax3':
                      this.form.adventureLevel[item] = val < 35 ? 35 : val > 40 ? 40 : val
                      break;*/
          case 'adventureLevelMin4':
          case 'adventureLevelMax4':
            this.form.adventureLevel[item] = val < 45 ? 45 : val > 50 ? 50 : val
            break;
          case 'adventureLevelMin5':
          case 'adventureLevelMax5':
            this.form.adventureLevel[item] = val < 50 ? 50 : val > 55 ? 55 : val
            break;
          case 'adventureLevelMin6':
          case 'adventureLevelMax6':
            this.form.adventureLevel[item] = val < 55 ? 55 : val > 60 ? 60 : val
            break;
        }
      }
      /*      if (this.form.adventureLevel.adventureLevelMax0 <= this.form.adventureLevel.adventureLevelMin0) this.form.adventureLevel.adventureLevelMax0 = ''
            if (this.form.adventureLevel.adventureLevelMin0 === '') this.form.adventureLevel.adventureLevelMax0 = ''
            if (this.form.adventureLevel.adventureLevelMax1 <= this.form.adventureLevel.adventureLevelMin1) this.form.adventureLevel.adventureLevelMax1 = ''
            if (this.form.adventureLevel.adventureLevelMin1 === '') this.form.adventureLevel.adventureLevelMax1 = ''
            if (this.form.adventureLevel.adventureLevelMax2 <= this.form.adventureLevel.adventureLevelMin2) this.form.adventureLevel.adventureLevelMax2 = ''
            if (this.form.adventureLevel.adventureLevelMin2 === '') this.form.adventureLevel.adventureLevelMax2 = ''
            if (this.form.adventureLevel.adventureLevelMax3 <= this.form.adventureLevel.adventureLevelMin3) this.form.adventureLevel.adventureLevelMax3 = ''
            if (this.form.adventureLevel.adventureLevelMin3 === '') this.form.adventureLevel.adventureLevelMax3 = ''*/
      if (this.form.adventureLevel.adventureLevelMax4 <= this.form.adventureLevel.adventureLevelMin4) this.form.adventureLevel.adventureLevelMax4 = ''
      if (this.form.adventureLevel.adventureLevelMin4 === '') this.form.adventureLevel.adventureLevelMax4 = ''
      if (this.form.adventureLevel.adventureLevelMax5 <= this.form.adventureLevel.adventureLevelMin5) this.form.adventureLevel.adventureLevelMax5 = ''
      if (this.form.adventureLevel.adventureLevelMin5 === '') this.form.adventureLevel.adventureLevelMax5 = ''
      if (this.form.adventureLevel.adventureLevelMax6 <= this.form.adventureLevel.adventureLevelMin6) this.form.adventureLevel.adventureLevelMax6 = ''
      if (this.form.adventureLevel.adventureLevelMin6 === '') this.form.adventureLevel.adventureLevelMax6 = ''
    },
    /**
     * 复制表单
     */
    copyForm() {
      let textarea = document.createElement("textarea");
      document.body.appendChild(textarea);
      textarea.value = this.textarea;
      textarea.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(textarea);
      this.$message({
        type: "success",
        center: true,
        message: '复制成功'
      })
    },

    /**
     * 联系客服
     */
    contactCustomerService() {
      if(this.$store.state.loginStatus){
        this.copyForm()
        this.$openIM({
          ysdgcode: 'ysdg',
          gameAlias: 'ysdg',
        })
        //
        // window.open('https://www13.53kf.com/webCompany.php?arg=10535611&kf_sign=jAxOTMTY2MI4ODEzNjM0MDU1MzAwMTM3MjUzNTYxMQ%253D%253D&style=28')
        this.copyFormShow = false
      }else{
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
          },
        })
      }
    }
  },
  watch: {
    'form.dailyCommission': {
      handler(newVal) {
        let levelUp = 0
        let comob = 0
        newVal.levelUp?.forEach(item => {
          levelUp = levelUp + item.price
        })
        for (let newValKey in newVal.comob) {
          if (newVal.comob[newValKey].val) {
            if (newValKey === 'comob4') {
              comob = comob + newVal.comob[newValKey].val * 688
            } else {
              comob = comob + newVal.comob[newValKey].val * (newVal.comob[newValKey].price ? newVal.comob[newValKey].price : 188)
            }
          }
        }
        this.form.dailyCommissionTotal = newVal.dailyStamina.val * newVal.dailyStamina.price + newVal.dailyStaminaBoss.val * newVal.dailyStaminaBoss.price
          + newVal.dailyCommission.val * newVal.dailyCommission.price + newVal.dogFood.val * newVal.dogFood.price
          + newVal.sportsCommittee.val * newVal.sportsCommittee.price
          + newVal.sperReceptacle.val * newVal.sperReceptacle.price + newVal.chronicle.val * newVal.chronicle.price + newVal.unchartedBoss.val * newVal.unchartedBoss.price
          + comob + levelUp
      },
      deep: true
    },
    'form.supernatural': {
      handler(newVal) {
        this.form.supernaturalTotal = 0
        newVal?.forEach(item => {
          this.form.supernaturalTotal = this.form.supernaturalTotal + item.price
        })
      },
      deep: true
    },
    'form.sakuraTree': {
      handler(newVal) {
        let treeLevel1 = 0
        let treeLevel2 = 0
        let treeLevel3 = 0
        let treeLevel4 = 0
        let treeLevel5 = 0
        let treeLevel6 = 0
        let treeLevel7 = 0
        let treeLevel8 = 0
        let treeLevel9 = 0
        let treeLevel10 = 0
        let treeLevel11 = 0
        let treeCombo = 0
        treeCombo = newVal.treeCombo.price ? newVal.treeCombo.price : 0
        newVal.treeCombo.forEach(item => {
          treeCombo = treeCombo + item.price
        })
        treeLevel1 = treeLevel1 + newVal.treeLevelMax1 - newVal.treeLevelMin1 > 0 ? (newVal.treeLevelMax1 - newVal.treeLevelMin1) * 8 : 0
        treeLevel2 = treeLevel2 + newVal.treeLevelMax2 - newVal.treeLevelMin2 > 0 ? (newVal.treeLevelMax2 - newVal.treeLevelMin2) * 11 : 0
        treeLevel3 = treeLevel3 + newVal.treeLevelMax3 - newVal.treeLevelMin3 > 0 ? (newVal.treeLevelMax3 - newVal.treeLevelMin3) * 14 : 0
        treeLevel4 = treeLevel4 + newVal.treeLevelMax4 - newVal.treeLevelMin4 > 0 ? (newVal.treeLevelMax4 - newVal.treeLevelMin4) * 15 : 0
        treeLevel5 = treeLevel5 + newVal.treeLevelMax5 - newVal.treeLevelMin5 > 0 ? (newVal.treeLevelMax5 - newVal.treeLevelMin5) * 17 : 0
        treeLevel6 = treeLevel6 + newVal.treeLevelMax6 - newVal.treeLevelMin6 > 0 ? (newVal.treeLevelMax6 - newVal.treeLevelMin6) * 19 : 0
        treeLevel7 = treeLevel7 + newVal.treeLevelMax7 - newVal.treeLevelMin7 > 0 ? (newVal.treeLevelMax7 - newVal.treeLevelMin7) * 21 : 0
        treeLevel8 = treeLevel8 + newVal.treeLevelMax8 - newVal.treeLevelMin8 > 0 ? (newVal.treeLevelMax8 - newVal.treeLevelMin8) * 23 : 0
        treeLevel9 = treeLevel9 + newVal.treeLevelMax9 - newVal.treeLevelMin9 > 0 ? (newVal.treeLevelMax9 - newVal.treeLevelMin9) * 26 : 0
        treeLevel10 = treeLevel10 + newVal.treeLevelMax10 - newVal.treeLevelMin10 > 0 ? (newVal.treeLevelMax10 - newVal.treeLevelMin10) * 15 : 0
        treeLevel11 = treeLevel11 + newVal.treeLevelMax11 - newVal.treeLevelMin11 > 0 ? (newVal.treeLevelMax11 - newVal.treeLevelMin11) * 17 : 0
        this.form.sakuraTreeTotal = treeLevel1 + treeLevel2 + treeLevel3 + treeLevel4 + treeLevel5 + treeLevel6 + treeLevel7 + treeLevel8 + treeLevel9 + treeLevel10 + treeLevel11 + treeCombo
      },
      deep: true
    },
    'form.mapExploration': {
      handler(newVal) {
        let maps = 0
        let degreeOfExp1 = 0
        let degreeOfExp2 = 0
        let mapsList = 0
        newVal.maps?.forEach(item => {
          maps = maps + item.price
        })
        if (newVal.degreeOfExpMax1 && newVal.degreeOfExpMin1) {
          degreeOfExp1 = degreeOfExp1 + newVal.degreeOfExpMax1 - newVal.degreeOfExpMin1 > 0 ? (newVal.degreeOfExpMax1 - newVal.degreeOfExpMin1) * 1 : 0
        }
        if (newVal.degreeOfExpMax2 && newVal.degreeOfExpMin2) {
          degreeOfExp2 = degreeOfExp2 + newVal.degreeOfExpMax2 - newVal.degreeOfExpMin2 > 0 ? (newVal.degreeOfExpMax2 - newVal.degreeOfExpMin2) * 2 : 0
        }
        newVal.mapsList.forEach(item => {
          mapsList = mapsList + item.price
        })
        this.form.mapExplorationTotal = maps + degreeOfExp1 + degreeOfExp2 + mapsList
      },
      deep: true
    },
    'form.materialOther': {
      handler(newVal) {
        let materialList0 = 0
        let materialList1 = 0
        let materialList2 = 0
        let materialList3 = 0
        let materialList4 = 0
        let rareMaterial = 0
        let rareMaterial1 = 0
        let rareMaterial2 = 0
        for (let materialList0Key in newVal.materialList0) {
          if (newVal.materialList0[materialList0Key]) {
            materialList0 = materialList0 + newVal.materialList0[materialList0Key] * 0.15
          }
        }
        for (let materialList1Key in newVal.materialList1) {
          if (newVal.materialList1[materialList1Key]) {
            materialList1 = materialList1 + newVal.materialList1[materialList1Key] * 0.2
          }
        }
        for (let materialList2Key in newVal.materialList2) {
          if (newVal.materialList2[materialList2Key]) {
            materialList2 = materialList2 + newVal.materialList2[materialList2Key] * 0.15
          }
        }
        for (let materialList3Key in newVal.materialList3) {
          if (newVal.materialList3[materialList3Key]) {
            materialList3 = materialList3 + newVal.materialList3[materialList3Key] * 0.3
          }
        }
        for (let materialList4Key in newVal.materialList4) {
          if (newVal.materialList4[materialList4Key]) {
            materialList4 = materialList4 + newVal.materialList4[materialList4Key] * 0.65
          }
        }
        this.rareMaterialList.forEach((item, index) => {
          if (newVal.rareMaterial[`material${index}`]) {
            rareMaterial = rareMaterial + newVal.rareMaterial[`material${index}`] * item.price
          }
        })
        this.rareMaterialList1.forEach((item, index) => {
          if (newVal.rareMaterial1[`material${index}`]) {
            rareMaterial1 = rareMaterial1 + newVal.rareMaterial1[`material${index}`] * item.price
          }
        })
        this.rareMaterialList2.forEach((item, index) => {
          if (newVal.rareMaterial2[`material${index}`]) {
            rareMaterial2 = rareMaterial2 + newVal.rareMaterial2[`material${index}`] * item.price
          }
        })
        this.form.materialOtherTotal = materialList0 + materialList1 + materialList2 + materialList3 + materialList4 + rareMaterial + rareMaterial1 + rareMaterial2
      },
      deep: true
    },
    'form.taskClass': {
      handler(newVal) {
        this.form.taskClassTotal = 0
        newVal?.forEach(item => {
          this.form.taskClassTotal = this.form.taskClassTotal + item.price
        })
      },
      deep: true
    },
    'form.breachClass': {
      handler(newVal) {
        this.form.breachClassTotal = 0
        newVal?.forEach(item => {
          this.form.breachClassTotal = this.form.breachClassTotal + item.price
        })
      },
      deep: true
    },
    'form.adventureLevel': {
      handler(newVal) {
        let comboTotal = 0
        newVal.adventureCombo.forEach(item => {
          comboTotal = comboTotal + item.price
        })
        // let adventureLevel0 = 0
        // let adventureLevel1 = 0
        // let adventureLevel2 = 0
        // let adventureLevel3 = 0
        let adventureLevel4 = 0
        let adventureLevel5 = 0
        let adventureLevel6 = 0
        // adventureLevel0 = adventureLevel0 + newVal.adventureLevelMax0 - newVal.adventureLevelMin0 > 0 ? (newVal.adventureLevelMax0 - newVal.adventureLevelMin0) * this.adventureLevelList[0].price : 0
        // adventureLevel1 = adventureLevel1 + newVal.adventureLevelMax1 - newVal.adventureLevelMin1 > 0 ? (newVal.adventureLevelMax1 - newVal.adventureLevelMin1) * this.adventureLevelList[1].price : 0
        // adventureLevel2 = adventureLevel2 + newVal.adventureLevelMax2 - newVal.adventureLevelMin2 > 0 ? (newVal.adventureLevelMax2 - newVal.adventureLevelMin2) * this.adventureLevelList[2].price : 0
        // adventureLevel3 = adventureLevel3 + newVal.adventureLevelMax3 - newVal.adventureLevelMin3 > 0 ? (newVal.adventureLevelMax3 - newVal.adventureLevelMin3) * this.adventureLevelList[3].price : 0
        adventureLevel4 = adventureLevel4 + newVal.adventureLevelMax4 - newVal.adventureLevelMin4 > 0 ? (newVal.adventureLevelMax4 - newVal.adventureLevelMin4) * this.adventureLevelList[0].price : 0
        let agioTotal4 = 0
        let agio4 = (newVal.adventureLevelMin4 - 45) * 5
        for (let i = 0; i < newVal.adventureLevelMax4 - newVal.adventureLevelMin4; i++) {
          agioTotal4 = agioTotal4 + agio4
          agio4 = agio4 + 5
        }
        adventureLevel4 = adventureLevel4 + agioTotal4
        adventureLevel5 = adventureLevel5 + newVal.adventureLevelMax5 - newVal.adventureLevelMin5 > 0 ? (newVal.adventureLevelMax5 - newVal.adventureLevelMin5) * this.adventureLevelList[1].price : 0
        let agioTotal5 = 0
        let agio5 = (newVal.adventureLevelMin5 - 50) * 50
        for (let i = 0; i < newVal.adventureLevelMax5 - newVal.adventureLevelMin5; i++) {
          agioTotal5 = agioTotal5 + agio5
          agio5 = agio5 + 50
        }
        adventureLevel5 = adventureLevel5 + agioTotal5
        adventureLevel6 = adventureLevel6 + newVal.adventureLevelMax6 - newVal.adventureLevelMin6 > 0 ? (newVal.adventureLevelMax6 - newVal.adventureLevelMin6) * this.adventureLevelList[2].price : 0
        let agioTotal6 = 0
        let agio6 = (newVal.adventureLevelMin6 - 55) * 500
        for (let i = 0; i < newVal.adventureLevelMax6 - newVal.adventureLevelMin6; i++) {
          agioTotal6 = agioTotal6 + agio6
          agio6 = agio6 + 500
        }
        adventureLevel6 = adventureLevel6 + agioTotal6
        this.adventureLevelTotalList = []
        // this.adventureLevelTotalList.push(adventureLevel0)
        // this.adventureLevelTotalList.push(adventureLevel1)
        // this.adventureLevelTotalList.push(adventureLevel2)
        // this.adventureLevelTotalList.push(adventureLevel3)
        this.adventureLevelTotalList.push(adventureLevel4)
        this.adventureLevelTotalList.push(adventureLevel5)
        this.adventureLevelTotalList.push(adventureLevel6)
        if (adventureLevel4 > 0 || adventureLevel5 > 0 || adventureLevel6 > 0) {
          this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
            if (it.speed === 'fast') it.disable = true;
            return it
          })
        } else if (adventureLevel4 === 0 && adventureLevel5 === 0 && adventureLevel6 === 0 && newVal.adventureCombo.length === 0) {
          this.adventureLevelCombo = this.adventureLevelCombo.map((it) => {
            if (it.speed === 'fast') it.disable = false;
            return it
          })
        }
        // this.form.adventureLevelTotal = adventureLevel0 + adventureLevel1 + adventureLevel2 + adventureLevel3 + adventureLevel4 + adventureLevel5 + adventureLevel6 + comboTotal
        this.form.adventureLevelTotal = adventureLevel4 + adventureLevel5 + adventureLevel6 + comboTotal
      },
      deep: true
    },
    'form': {
      handler(val) {
        // if (val.customize === '') {
        //   val.remark = ''
        // }
        this.total = 0
        this.textarea = ''
        this.total = math.add(val.dailyCommissionTotal, val.supernaturalTotal, val.mapExplorationTotal, val.materialOtherTotal, val.sakuraTreeTotal, val.taskClassTotal, val.breachClassTotal, val.adventureLevelTotal, val.customize)
        let comob = ``
        let comobIndex = 0
        for (let comobKey in val.dailyCommission.comob) {
          comobIndex++
          if (val.dailyCommission.comob[comobKey].val) {
            let duration
            if (this.comboList[comobIndex - 1].unitPrice.length > 1) {
              if (val.dailyCommission.comob[comobKey].price == this.comboList[comobIndex - 1].unitPrice[0].price) {
                duration = this.comboList[comobIndex - 1].unitPrice[0].label
              } else {
                duration = this.comboList[comobIndex - 1].unitPrice[1].label
              }
            } else {
              duration = '月'
            }
            comob = `套餐${comobIndex}:${this.comboList[comobIndex - 1].text} ${val.dailyCommission.comob[comobKey].val}${duration}`
          }
        }
        let levelUp = ``
        val.dailyCommission.levelUp?.forEach((item, index) => {
          levelUp = levelUp + `${item.label}${index !== val.dailyCommission.levelUp.length - 1 ? '、' : ''}`
        })
        let supernatural = ``
        val.supernatural?.forEach((item, index) => {
          supernatural = supernatural + `${item.label}${index !== val.supernatural.length - 1 ? '\n' : ''}`
        })
        let treeCombo = ``
        val.sakuraTree.treeCombo?.forEach((item, index) => {
          treeCombo = treeCombo + `${item.text}${index !== val.sakuraTree.treeCombo.length - 1 ? '\n' : ''}`
        })
        let maps = ``
        val.mapExploration.maps?.forEach((item, index) => {
          maps = maps + `${item.label}${index !== val.mapExploration.maps.length - 1 ? '\n' : ''}`
        })
        let mapsList = ``
        val.mapExploration.mapsList?.forEach((item, index) => {
          mapsList = mapsList + `${item.text}${index !== val.mapExploration.mapsList.length - 1 ? '\n' : ''}`
        })
        let materialList0 = ``
        let materialList0index = 0
        for (let materialList0Key in val.materialOther.materialList0) {
          materialList0index++
          if (val.materialOther.materialList0[materialList0Key]) {
            materialList0 = materialList0 + `${this.materialList[0].list[materialList0index - 1]} - ${val.materialOther.materialList0[materialList0Key]}个\n`
          }
        }
        let materialList1 = ``
        let materialList1index = 0
        for (let materialList1Key in val.materialOther.materialList1) {
          materialList1index++
          if (val.materialOther.materialList1[materialList1Key]) {
            materialList1 = materialList1 + `${this.materialList[1].list[materialList1index - 1]} - ${val.materialOther.materialList1[materialList1Key]}个\n`
          }
        }
        let materialList2 = ``
        let materialList2index = 0
        for (let materialList2Key in val.materialOther.materialList2) {
          materialList2index++
          if (val.materialOther.materialList2[materialList2Key]) {
            materialList2 = materialList2 + `${this.materialList[2].list[materialList2index - 1]} - ${val.materialOther.materialList2[materialList2Key]}个\n`
          }
        }
        let materialList3 = ``
        let materialList3index = 0
        for (let materialList3Key in val.materialOther.materialList3) {
          materialList3index++
          if (val.materialOther.materialList3[materialList3Key]) {
            materialList3 = materialList3 + `${this.materialList[3].list[materialList3index - 1]} - ${val.materialOther.materialList3[materialList3Key]}个\n`
          }
        }
        let materialList4 = ``
        let materialList4index = 0
        for (let materialList4Key in val.materialOther.materialList4) {
          materialList4index++
          if (val.materialOther.materialList4[materialList4Key]) {
            materialList4 = materialList4 + `${this.materialList[4].list[materialList4index - 1]} - ${val.materialOther.materialList4[materialList4Key]}个\n`
          }
        }
        let rareMaterial = ``
        this.rareMaterialList.forEach((item, index) => {
          if (val.materialOther.rareMaterial[`material${index}`]) {
            rareMaterial = rareMaterial + `${item.label} - ${val.materialOther.rareMaterial[`material${index}`]} * ${item.company}\n`
          }
        })
        let rareMaterial1 = ``
        this.rareMaterialList1.forEach((item, index) => {
          if (val.materialOther.rareMaterial1[`material${index}`]) {
            rareMaterial1 = rareMaterial1 + `${item.label} - ${val.materialOther.rareMaterial1[`material${index}`]}个\n`
          }
        })
        let rareMaterial2 = ``
        this.rareMaterialList1.forEach((item, index) => {
          if (val.materialOther.rareMaterial2[`material${index}`]) {
            rareMaterial2 = rareMaterial2 + `${item.label} - ${val.materialOther.rareMaterial2[`material${index}`]}个\n`
          }
        })
        let taskClass = ``
        val.taskClass?.forEach((item, index) => {
          taskClass = taskClass + `${item.label}${index !== val.taskClass.length - 1 ? '\n' : ''}`
        })
        let breachClass = ``
        val.breachClass?.forEach((item, index) => {
          breachClass = breachClass + `${item.label}${index !== val.breachClass.length - 1 ? '\n' : ''}`
        })
        let adventureCombo = ``
        let adventureComboType = ``
        this.form.adventureLevel.adventureCombo.forEach((item, index) => {
          if (index === 0) {
            if (item.speed === 'fast') adventureComboType = `极速版`
            else adventureComboType = `普通版`
          }
          adventureCombo = adventureCombo + `${item.label}\n`
        })
        let adventureLevel = ``
        this.adventureLevelList.forEach((item, index) => {
          if (val.adventureLevel[`adventureLevelMax${index + 4}`] - val.adventureLevel[`adventureLevelMin${index + 4}`] > 0) {
            adventureLevel = adventureLevel + `等级套餐：${val.adventureLevel[`adventureLevelMin${index + 4}`]} - ${val.adventureLevel[`adventureLevelMax${index + 4}`]}\n`
          }
        })
        this.textarea = `${val.dailyCommissionTotal > 0 ? '日常委托\n' : ''}` +
          `${val.dailyCommission.dailyStamina.val ?
            `日常体力不指定副本/BOSS ${val.dailyCommission.dailyStamina.val}${val.dailyCommission.dailyStamina.price == 3 ? '天' : '月'}\n` : ''}` +
          `${val.dailyCommission.dailyStaminaBoss.val ?
            `日常体力指定副本/BOSS ${val.dailyCommission.dailyStaminaBoss.val}${val.dailyCommission.dailyStaminaBoss.price == 5 ? '天' : '月'}\n` : ''}` +
          `${val.dailyCommission.dailyCommission.val ?
            `日常委托 ${val.dailyCommission.dailyCommission.val}${val.dailyCommission.dailyCommission.price == 2 ? '天' : '月'}\n` : ''}` +
          `${val.dailyCommission.dogFood.val ?
            `捡圣遗物狗粮 ${val.dailyCommission.dogFood.val}${val.dailyCommission.dogFood.price == 7 ? '天' : '月'}\n` : ''}` +
          `${val.dailyCommission.sportsCommittee.val ?
            `体委 ${val.dailyCommission.sportsCommittee.val}月\n` : ''}` +
          `${val.dailyCommission.sperReceptacle.val ?
            `精托 ${val.dailyCommission.sperReceptacle.val}月\n` : ''}` +
          `${val.dailyCommission.unchartedBoss.val ?
            `秘境/Boss ${val.dailyCommission.unchartedBoss.val}次\n\n` : ''}` +
          `${val.dailyCommission.chronicle.val ?
            `纪行10级 ${val.dailyCommission.chronicle.val}周\n\n` : ''}` +
          `${comob.length > 1 ? `${comob}\n` : ''}` +
          `${levelUp.length > 1 ? `突破等级：${levelUp}，（经验书号主自备，还需有体力）\n\n` : ''}` +
          `${val.supernaturalTotal > 0 ? '神瞳类\n' : ''}` +
          `${supernatural.length > 1 ? `${supernatural}\n\n` : ''}` +
          `${val.sakuraTreeTotal > 0 ? '树类等级提升\n' : ''}` +
          `${treeCombo.length > 1 ? `${treeCombo}\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax1 - val.sakuraTree.treeLevelMin1) > 0 ?
            `神樱树 ${val.sakuraTree.treeLevelMin1} - ${val.sakuraTree.treeLevelMax1}级\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax2 - val.sakuraTree.treeLevelMin2) > 0 ?
            `神樱树 ${val.sakuraTree.treeLevelMin2} - ${val.sakuraTree.treeLevelMax2}级\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax3 - val.sakuraTree.treeLevelMin3) > 0 ?
            `神樱树 ${val.sakuraTree.treeLevelMin3} - ${val.sakuraTree.treeLevelMax3}级\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax4 - val.sakuraTree.treeLevelMin4) > 0 ?
            `梦之树 ${val.sakuraTree.treeLevelMin4} - ${val.sakuraTree.treeLevelMax4}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax5 - val.sakuraTree.treeLevelMin5) > 0 ?
            `梦之树 ${val.sakuraTree.treeLevelMin5} - ${val.sakuraTree.treeLevelMax5}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax6 - val.sakuraTree.treeLevelMin6) > 0 ?
            `梦之树 ${val.sakuraTree.treeLevelMin6} - ${val.sakuraTree.treeLevelMax6}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax7 - val.sakuraTree.treeLevelMin7) > 0 ?
            `梦之树 ${val.sakuraTree.treeLevelMin7} - ${val.sakuraTree.treeLevelMax7}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax8 - val.sakuraTree.treeLevelMin8) > 0 ?
            `梦之树 ${val.sakuraTree.treeLevelMin8} - ${val.sakuraTree.treeLevelMax8}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax9 - val.sakuraTree.treeLevelMin9) > 0 ?
            `梦之树 ${val.sakuraTree.treeLevelMin9} - ${val.sakuraTree.treeLevelMax9}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax10 - val.sakuraTree.treeLevelMin10) > 0 ?
            `露景泉 ${val.sakuraTree.treeLevelMin10} - ${val.sakuraTree.treeLevelMax10}级\n\n` : ''}` +
          `${(val.sakuraTree.treeLevelMax11 - val.sakuraTree.treeLevelMin11) > 0 ?
            `露景泉 ${val.sakuraTree.treeLevelMin11} - ${val.sakuraTree.treeLevelMax11}级\n\n` : ''}` +
          // `${val.sakuraTree.treeCombo.text ? `套餐 : ${val.sakuraTree.treeCombo.text}\n\n` : ''}` +
          `${val.mapExplorationTotal > 0 ? '地图探索\n' : ''}` +
          `${maps.length > 1 ? `${maps}\n\n` : ''}` +
          `${mapsList.length > 1 ? `${mapsList}\n\n` : ''}` +

          `${(val.mapExploration.degreeOfExpMax1 - val.mapExploration.degreeOfExpMin1) > 0 ?
            `补探索度 ${val.mapExploration.degreeOfExpMin1} - ${val.mapExploration.degreeOfExpMax1}\n` : ''}` +
          `${(val.mapExploration.degreeOfExpMax2 - val.mapExploration.degreeOfExpMin2) > 0 ?
            `补探索度 ${val.mapExploration.degreeOfExpMin2} - ${val.mapExploration.degreeOfExpMax2}\n\n` : ''}` +
          `${val.materialOtherTotal > 0 ? '材料搜集\n' : ''}` +
          `${materialList0.length > 1 ? `${materialList0}` : ''}` +
          `${materialList1.length > 1 ? `${materialList1}` : ''}` +
          `${rareMaterial.length > 1 ? `${rareMaterial}\n` : ''}` +
          `${materialList2.length > 1 ? `${materialList2}` : ''}` +
          `${materialList3.length > 1 ? `${materialList3}` : ''}` +
          `${materialList4.length > 1 ? `${materialList4}` : ''}` +
          `${rareMaterial1.length > 1 ? `${rareMaterial1}\n` : ''}` +
          `${rareMaterial2.length > 1 ? `${rareMaterial2}\n` : ''}` +
          `${val.taskClassTotal > 0 ? '任务类\n' : ''}` +
          `${taskClass.length > 1 ? `${taskClass}\n\n` : ''}` +
          `${val.breachClassTotal > 0 ? '角色/武器突破\n' : ''}` +
          `${breachClass.length > 1 ? `${breachClass}\n\n` : ''}` +
          `${val.adventureLevelTotal > 0 ? '冒险等级\n' : ''}` +
          `${adventureCombo.length > 1 ? `${adventureComboType}\n${adventureCombo}` : ''}` +
          `${adventureLevel.length > 1 ? `${adventureLevel}\n` : ''}` +
          `${val.customize ? '自定义\n' : ''}` +
          `${val.customize ? `补款类 ${val.customize}件\n` : ''}` +
          `${val.remark ? `备注信息 ${val.remark}\n\n` : ''}` +
          `${this.total != 0 ? `合计：${this.total.toFixed(2)}\n` : ''}`
      },
      deep: true
    },
  }
}
</script>

<style scoped lang="less">

/deep/ .el-input__inner {
  width: 70px;
  height: 30px;
  border: 1px solid var(--border-soft, #E8E4DE);
  border-radius: 4px;
  padding: 6px 10px 6px 10px;
  color: var(--text-main, #111827);
  background: var(--bg-card, #FFFFFF);
}

/deep/ .el-input {
  width: auto;
}

/deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
  background: var(--bg-section, #F7F5F2);
  border: 1px solid var(--border-strong, #CBD5E1);
  border-radius: 4px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: var(--brand-blue, #1A1D24);
  border: 1px solid var(--brand-blue, #1A1D24);
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border: 1px solid var(--brand-blue, #1A1D24);
}

/deep/ .el-checkbox__inner::after {
  //border: 2px solid #FFFFFF;
  height: 10px;
  width: 5px;
  left: 6px;
  top: 2px;
}

/deep/ .el-textarea__inner {
  border: none;
  background: var(--bg-section, #F7F5F2) !important;
  color: var(--text-main, #111827);
}

/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
  -moz-appearance: textfield;
}

.training {
  width: 1200px;
  box-sizing: border-box;
  color: var(--text-main, #111827);

  .banner {
    margin: 0 0 10px;

    img {
      display: block;
      width: 100%;
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    }
  }

  .main {
    background: var(--bg-card, #FFFFFF);
    padding: 23px 44px 40px;
    min-height: 100vh;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .form {
      margin: 0 0 40px;

      .formBody {
        border: 1px solid var(--border-soft, #E8E4DE);
        border-bottom: none;
        border-radius: 0 4px 4px 4px;
        overflow: hidden;
        background: var(--bg-card, #FFFFFF);

        .formItem {
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
          padding: 20px 27px 5px;

          .li-item {
            margin: 0 0 15px;
          }

          .li-item-detail, .comboList > .comboItem, .materialList > .materialItem {
            display: flex;
            align-items: center;

            .comob-month {
              display: flex;
              align-items: center;

              > .month {
                background: var(--brand-blue, #1A1D24);
                width: 35px;
                height: 24px;
                line-height: 24px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 400;
                text-align: center;
                border-radius: 4px;
              }

              .priceTip {
                color: var(--text-muted, #9AA0AC);
                font-size: 14px;
                font-weight: 400;
                white-space: nowrap;
              }
            }

            .li-item-text, .priceTip {
              color: var(--text-main, #111827);
              font-size: 14px;
              font-weight: 400;
              white-space: nowrap;
            }

            .li-item-input {
              margin: 0 10px;
            }

            .priceTip {
              color: var(--text-muted, #9AA0AC);
            }

            .li-item-tip {
              width: 195px;
              height: 28px;
              background: var(--brand-blue-light, #F0EDE8);
              font-size: 14px;
              font-weight: 400;
              color: var(--brand-blue, #1A1D24);
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;

              span {
                margin: 0 6px 0 0;
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 4px;
                background: rgba(255, 255, 255, 1);
                box-shadow: inset -0.5px -0.5px 1px 0 rgba(26, 29, 36, 0.25);
              }
            }

          }

          .comboTitle {
            color: var(--text-main, #111827);
            font-size: 14px;
            font-weight: 400;
            display: flex;
            align-items: center;
            margin: 0 0 15px;

            img {
              margin: 0 5px 0 0;
            }

            .comboTip {
              margin: 0 0 0 5px;
              font-size: 14px;
              font-weight: 400;
              padding: 5px 21px;
              color: rgba(232, 90, 90, 1);
              background: var(--danger-soft, #FEF2F2);
              border: 1px solid rgba(239, 68, 68, 0.18);
              border-radius: 4px;
            }
          }

          .comboList {
            .comboItem {
              padding: 21px 0 15px;
              border-top: 1px solid var(--border-soft, #E8E4DE);

              .combo-index {
                flex-shrink: 0;
                width: 20px;
                height: 20px;
                line-height: 20px;
                color: rgba(255, 255, 255, 1);
                background: var(--brand-blue, #1A1D24);
                font-size: 14px;
                font-weight: 400;
                text-align: center;
                margin: 0 11px 0 0;
              }

              .combo-text {

                flex-shrink: 0;
                width: 635px;
                color: var(--text-main, #111827);
                font-size: 14px;
                font-weight: 400;
                //white-space: nowrap;
              }

              .comob-month {
                display: flex;
                align-items: center;

                > .month {
                  background: var(--brand-blue, #1A1D24);
                  width: 35px;
                  height: 24px;
                  line-height: 24px;
                  color: rgba(255, 255, 255, 1);
                  font-size: 14px;
                  font-weight: 400;
                  text-align: center;
                  border-radius: 4px;
                }

                .priceTip {
                  color: var(--text-muted, #9AA0AC);
                  font-size: 14px;
                  font-weight: 400;
                  white-space: nowrap;
                }
              }

              .comboCheckbox {
                margin: 0 0 0 40px;
              }
            }
          }

          .levelUpTitle {
            display: flex;
            align-items: center;
            color: var(--text-main, #111827);
            font-size: 16px;
            font-weight: 400;

            span {
              width: 6px;
              height: 6px;
              background: var(--brand-blue, #1A1D24);
              margin: 0 10px 0 0;
            }

            .levelUpTitle-tip {
              height: 28px;
              padding: 4px 10px 4px 7px;
              background: var(--brand-blue-light, #F0EDE8);
              border-radius: 4px;
              color: var(--brand-blue, #1A1D24);
              font-size: 14px;
              font-weight: 400;
              display: flex;
              align-items: center;

              span {
                width: 8px;
                height: 8px;
                border-radius: 4px;
                background: rgba(255, 255, 255, 1);
                box-shadow: inset -0.5px -0.5px 1px rgba(26, 29, 36, 0.25);
                margin: 0 6px 0 0;
              }
            }
          }

          .formCheckbox {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin: 15px 0;

            .formCheckbox-Item {
              padding: 7px 33px;
              background: var(--bg-section, #F7F5F2);
              border-radius: 4px;
              margin: 0 20px 20px 0;
              border: 1px solid var(--border-soft, #E8E4DE);
              cursor: pointer;
              transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;

              .formCheckbox-Item-label {
                margin: 0 20px 0 0;
              }

              span {
                color: var(--text-secondary, #5A5F6B);
                font-size: 14px;
                font-weight: 400;
              }
            }

            .formCheckbox-Item-Active {
              background: var(--brand-blue-light, #F0EDE8);
              border: 1px solid var(--brand-blue, #1A1D24);
              box-shadow: 0 4px 12px rgba(26, 29, 36, 0.12);

              span {
                color: var(--brand-blue, #1A1D24);
              }
            }

            .formCheckbox-Item-Disable {
              cursor: not-allowed !important;
              background: #F1F5F9;
              color: var(--text-muted, #9AA0AC);
              border-color: var(--border-soft, #E8E4DE);
            }

            .formCheckbox-Item:hover {
              border: 1px solid var(--brand-blue, #1A1D24);
            }
          }

          .materialPrice {
            flex-shrink: 0;
            width: 59px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            font-weight: 400;
            background: var(--brand-blue, #1A1D24);
            border-radius: 4px;
            margin: 0 30px 0 0;
          }

          .materialList {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .materialItem {
              display: flex;
              align-items: center;
              margin: 0 40px 20px 0;
            }
          }
        }

        .formTotal {
          padding: 20px 27px;
          color: var(--text-main, #111827);
          font-size: 16px;
          font-weight: 400;

          span {
            margin: 0 0 0 8px;
            font-size: 24px;
          }
        }

        .formItem-tip {
          font-size: 14px;
          font-weight: 400;
          color: #E85A5A;
          padding: 5px 20px !important;
          background: var(--danger-soft, #FEF2F2);
          display: inline-block;
          border: 1px solid rgba(239, 68, 68, 0.18);
          border-radius: 4px;

        }

        .remark {
          width: 404px;
          margin: 0 0 5px;

          /deep/ .el-textarea__inner {
            border: 1px solid var(--border-soft, #E8E4DE) !important;
            background: #FFFFFF !important;
          }
        }
      }

      .materialOther {
        border-bottom: 1px solid var(--border-soft, #E8E4DE);

        .material {
          .collectMaterials-title {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: var(--text-main, #111827);
            border-bottom: 1px solid var(--border-soft, #E8E4DE);
            padding: 0 0 15px;

            span {
              width: 6px;
              height: 6px;
              display: block;
              background: var(--brand-blue, #1A1D24);
              margin: 0 10px 0 0;
            }
          }

          padding: 18px 27px 0;

          .collectMaterials-body {
            .formItem {
              padding: 20px 0 5px;
            }

            .formTotal {
              border: none;
            }
          }
        }

        .collectMaterials {
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
        }

        .beatingMaterials {
          padding: 18px 27px;
          border-bottom: 1px solid var(--border-soft, #E8E4DE);

          .collectMaterials-body {
            .formItem {
              .materialPrice {
                width: auto;
                height: auto;
                padding: 5px 10px;

                div:last-of-type {
                  font-size: 12px;
                }

              }

            }
          }

        }


      }

      .adventureLevel {
        .formItem {
          .adventureComboTitle {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: var(--text-main, #111827);
            margin: 0 0 15px;

            span {
              width: 6px;
              height: 6px;
              background: var(--brand-blue, #1A1D24);
              margin: 0 10px 0 0;
              display: block;
            }
          }

          .formCheckbox {
            .formCheckbox-Item {
              display: flex;
              flex-direction: column;
              align-items: center;
              min-width: 94px;;

              span {
                display: block;
              }

              .adventureLevel-lebel {
                margin: 0;
              }
            }

          }
        }

      }
    }

    .form-tip{
      font-size: 14px;
      font-weight: 400;
      color: #E85A5A;
      padding: 5px 20px !important;
      background: var(--danger-soft, #FEF2F2);
      display: inline-block;
      border: 1px solid rgba(239, 68, 68, 0.18);
      border-radius: 4px;
      margin: 0 0 20px;
    }

    .form-footer {
      display: flex;
      align-items: center;
      gap: 50px;

      .footer-card {
        width: 500px;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        overflow: hidden;
        background: var(--bg-card, #FFFFFF);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

        .footer-title {
          padding: 0 16px 0 20px;
          height: 46px;
          background: linear-gradient(135deg, #1A1D24 0%, #5A5F6B 100%);
          border-bottom: none;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .footer-total {
            color: rgba(255, 255, 255, 1);
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;

            &::before {
              content: "";
              width: 3px;
              height: 16px;
              margin: 0 10px 0 0;
              background: rgba(255, 255, 255, 0.86);
              border-radius: 3px;
            }
          }

          > .footer-btnGroup {
            display: flex;
            align-items: center;
            gap: 8px;

            .footer-btn {
              height: 28px;
              padding: 0 10px;
              margin: 0;
              color: rgba(255, 255, 255, 0.9);
              background: rgba(255, 255, 255, 0.1);
              border: 1px solid rgba(255, 255, 255, 0.16);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              cursor: pointer;
              display: flex;
              align-items: center;
              transition: background-color 0.2s, border-color 0.2s;

              img {
                width: 14px;
                height: 14px;
                margin: 0 5px 0 0;
                opacity: 0.86;
              }
            }

            .footer-btn:hover {
              background: rgba(255, 255, 255, 0.16);
              border-color: rgba(255, 255, 255, 0.28);
            }

          }

        }

        .footer-input {
          border: none;
          background: var(--bg-card, #FFFFFF);

          /deep/ .el-textarea__inner {
            border: none;
            border-radius: 0;
            background: var(--bg-section, #F7F5F2) !important;
            color: var(--text-secondary, #5A5F6B);
          }
        }
      }

      .footer-other {
        width: auto;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        background: transparent;
        border: none;
        border-radius: 0;
        box-shadow: none;
        display: flex;
        flex-direction: column;
        align-self: stretch;
        justify-content: flex-end;

        .footer-price {
          color: var(--text-main, #111827);
          font-size: 16px;
          font-weight: 500;

          span {
            color: var(--primary, #FF7A1A);
            font-size: 20px;
            font-weight: 600;

            #totalPrice {
              color: var(--primary, #FF7A1A);
              font-size: 28px;
              font-weight: 500;
            }
          }
        }

        > .footer-btnGroup {
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 20px 0 0;

          div {
            width: 112px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            border-radius: 4px;
            transition: box-shadow .24s ease, background-position .32s ease, background-color .24s ease, border-color .24s ease, color .24s ease;
          }

          .footer-btn-cusSer {
            color: var(--brand-blue, #1A1D24);
            background: var(--brand-blue-light, #F0EDE8);
            border: 1px solid rgba(26, 29, 36, 0.18);
          }

          .footer-btn-buy {
            color: rgba(255, 255, 255, 1);
            background: linear-gradient(120deg, #1A1D24 0%, #1A1D24 48%, #1A1D24 100%);
            background-size: 220% 100%;
            background-position: 0 50%;
            box-shadow: 0 8px 16px rgba(26, 29, 36, 0.12);
          }

          .footer-btn-cusSer:hover {
            color: #1A1D24;
            background: #F0EDE8;
            border-color: rgba(26, 29, 36, 0.36);
            box-shadow: 0 6px 14px rgba(26, 29, 36, 0.1);
          }

          .footer-btn-buy:hover {
            background-position: 100% 50%;
            box-shadow: 0 10px 20px rgba(26, 29, 36, 0.14);
          }
        }


      }

    }
  }
}

.btnGroup {
  display: flex;
  align-items: center;

  /deep/ .btn {
    width: 148px !important;
    height: 38px !important;
    border-radius: 4px !important;
    margin: 0 5px !important;
    border: 1px solid var(--brand-blue, #1A1D24);
  }

  .cancelBtn {
    border: 1px solid var(--border-strong, #CBD5E1);
    background: #FFFFFF !important;
  }
}
</style>
